import { r as pt, c as _t, h as g, H as mt, g as bt } from "./main-bb89b2f2.js";
import { D as wt } from "./luxon-88c249ba-ecb6bfbf.js";
import { T as I } from "./translation-service-06f7c8c7-b6396601.js";
import "vue";
class v extends Error {
  /** Constructs a new instance of {@link @microsoft/signalr.HttpError}.
   *
   * @param {string} errorMessage A descriptive error message.
   * @param {number} statusCode The HTTP status code represented by this error.
   */
  constructor(e, t) {
    const n = new.target.prototype;
    super(`${e}: Status code '${t}'`), this.statusCode = t, this.__proto__ = n;
  }
}
class D extends Error {
  /** Constructs a new instance of {@link @microsoft/signalr.TimeoutError}.
   *
   * @param {string} errorMessage A descriptive error message.
   */
  constructor(e = "A timeout occurred.") {
    const t = new.target.prototype;
    super(e), this.__proto__ = t;
  }
}
class y extends Error {
  /** Constructs a new instance of {@link AbortError}.
   *
   * @param {string} errorMessage A descriptive error message.
   */
  constructor(e = "An abort occurred.") {
    const t = new.target.prototype;
    super(e), this.__proto__ = t;
  }
}
class yt extends Error {
  /** Constructs a new instance of {@link @microsoft/signalr.UnsupportedTransportError}.
   *
   * @param {string} message A descriptive error message.
   * @param {HttpTransportType} transport The {@link @microsoft/signalr.HttpTransportType} this error occurred on.
   */
  constructor(e, t) {
    const n = new.target.prototype;
    super(e), this.transport = t, this.errorType = "UnsupportedTransportError", this.__proto__ = n;
  }
}
class St extends Error {
  /** Constructs a new instance of {@link @microsoft/signalr.DisabledTransportError}.
   *
   * @param {string} message A descriptive error message.
   * @param {HttpTransportType} transport The {@link @microsoft/signalr.HttpTransportType} this error occurred on.
   */
  constructor(e, t) {
    const n = new.target.prototype;
    super(e), this.transport = t, this.errorType = "DisabledTransportError", this.__proto__ = n;
  }
}
class vt extends Error {
  /** Constructs a new instance of {@link @microsoft/signalr.FailedToStartTransportError}.
   *
   * @param {string} message A descriptive error message.
   * @param {HttpTransportType} transport The {@link @microsoft/signalr.HttpTransportType} this error occurred on.
   */
  constructor(e, t) {
    const n = new.target.prototype;
    super(e), this.transport = t, this.errorType = "FailedToStartTransportError", this.__proto__ = n;
  }
}
class H extends Error {
  /** Constructs a new instance of {@link @microsoft/signalr.FailedToNegotiateWithServerError}.
   *
   * @param {string} message A descriptive error message.
   */
  constructor(e) {
    const t = new.target.prototype;
    super(e), this.errorType = "FailedToNegotiateWithServerError", this.__proto__ = t;
  }
}
class Ct extends Error {
  /** Constructs a new instance of {@link @microsoft/signalr.AggregateErrors}.
   *
   * @param {string} message A descriptive error message.
   * @param {Error[]} innerErrors The collection of errors this error is aggregating.
   */
  constructor(e, t) {
    const n = new.target.prototype;
    super(e), this.innerErrors = t, this.__proto__ = n;
  }
}
class z {
  constructor(e, t, n) {
    this.statusCode = e, this.statusText = t, this.content = n;
  }
}
class R {
  get(e, t) {
    return this.send({
      ...t,
      method: "GET",
      url: e
    });
  }
  post(e, t) {
    return this.send({
      ...t,
      method: "POST",
      url: e
    });
  }
  delete(e, t) {
    return this.send({
      ...t,
      method: "DELETE",
      url: e
    });
  }
  /** Gets all cookies that apply to the specified URL.
   *
   * @param url The URL that the cookies are valid for.
   * @returns {string} A string containing all the key-value cookie pairs for the specified URL.
   */
  // @ts-ignore
  getCookieString(e) {
    return "";
  }
}
var r;
(function(s) {
  s[s.Trace = 0] = "Trace", s[s.Debug = 1] = "Debug", s[s.Information = 2] = "Information", s[s.Warning = 3] = "Warning", s[s.Error = 4] = "Error", s[s.Critical = 5] = "Critical", s[s.None = 6] = "None";
})(r || (r = {}));
class E {
  constructor() {
  }
  /** @inheritDoc */
  // eslint-disable-next-line
  log(e, t) {
  }
}
E.instance = new E();
const kt = "8.0.7";
class _ {
  static isRequired(e, t) {
    if (e == null)
      throw new Error(`The '${t}' argument is required.`);
  }
  static isNotEmpty(e, t) {
    if (!e || e.match(/^\s*$/))
      throw new Error(`The '${t}' argument should not be empty.`);
  }
  static isIn(e, t, n) {
    if (!(e in t))
      throw new Error(`Unknown ${n} value: ${e}.`);
  }
}
class p {
  // react-native has a window but no document so we should check both
  static get isBrowser() {
    return !p.isNode && typeof window == "object" && typeof window.document == "object";
  }
  // WebWorkers don't have a window object so the isBrowser check would fail
  static get isWebWorker() {
    return !p.isNode && typeof self == "object" && "importScripts" in self;
  }
  // react-native has a window but no document
  static get isReactNative() {
    return !p.isNode && typeof window == "object" && typeof window.document > "u";
  }
  // Node apps shouldn't have a window object, but WebWorkers don't either
  // so we need to check for both WebWorker and window
  static get isNode() {
    return typeof process < "u" && process.release && process.release.name === "node";
  }
}
function $(s, e) {
  let t = "";
  return k(s) ? (t = `Binary data of length ${s.byteLength}`, e && (t += `. Content: '${Tt(s)}'`)) : typeof s == "string" && (t = `String data of length ${s.length}`, e && (t += `. Content: '${s}'`)), t;
}
function Tt(s) {
  const e = new Uint8Array(s);
  let t = "";
  return e.forEach((n) => {
    const o = n < 16 ? "0" : "";
    t += `0x${o}${n.toString(16)} `;
  }), t.substr(0, t.length - 1);
}
function k(s) {
  return s && typeof ArrayBuffer < "u" && (s instanceof ArrayBuffer || // Sometimes we get an ArrayBuffer that doesn't satisfy instanceof
  s.constructor && s.constructor.name === "ArrayBuffer");
}
async function q(s, e, t, n, o, i) {
  const a = {}, [c, l] = T();
  a[c] = l, s.log(r.Trace, `(${e} transport) sending data. ${$(o, i.logMessageContent)}.`);
  const h = k(o) ? "arraybuffer" : "text", d = await t.post(n, {
    content: o,
    headers: { ...a, ...i.headers },
    responseType: h,
    timeout: i.timeout,
    withCredentials: i.withCredentials
  });
  s.log(r.Trace, `(${e} transport) request complete. Response status: ${d.statusCode}.`);
}
function It(s) {
  return s === void 0 ? new P(r.Information) : s === null ? E.instance : s.log !== void 0 ? s : new P(s);
}
class Et {
  constructor(e, t) {
    this._subject = e, this._observer = t;
  }
  dispose() {
    const e = this._subject.observers.indexOf(this._observer);
    e > -1 && this._subject.observers.splice(e, 1), this._subject.observers.length === 0 && this._subject.cancelCallback && this._subject.cancelCallback().catch((t) => {
    });
  }
}
class P {
  constructor(e) {
    this._minLevel = e, this.out = console;
  }
  log(e, t) {
    if (e >= this._minLevel) {
      const n = `[${(/* @__PURE__ */ new Date()).toISOString()}] ${r[e]}: ${t}`;
      switch (e) {
        case r.Critical:
        case r.Error:
          this.out.error(n);
          break;
        case r.Warning:
          this.out.warn(n);
          break;
        case r.Information:
          this.out.info(n);
          break;
        default:
          this.out.log(n);
          break;
      }
    }
  }
}
function T() {
  let s = "X-SignalR-User-Agent";
  return p.isNode && (s = "User-Agent"), [s, $t(kt, At(), Rt(), Pt())];
}
function $t(s, e, t, n) {
  let o = "Microsoft SignalR/";
  const i = s.split(".");
  return o += `${i[0]}.${i[1]}`, o += ` (${s}; `, e && e !== "" ? o += `${e}; ` : o += "Unknown OS; ", o += `${t}`, n ? o += `; ${n}` : o += "; Unknown Runtime Version", o += ")", o;
}
function At() {
  if (p.isNode)
    switch (process.platform) {
      case "win32":
        return "Windows NT";
      case "darwin":
        return "macOS";
      case "linux":
        return "Linux";
      default:
        return process.platform;
    }
  else
    return "";
}
function Pt() {
  if (p.isNode)
    return process.versions.node;
}
function Rt() {
  return p.isNode ? "NodeJS" : "Browser";
}
function N(s) {
  return s.stack ? s.stack : s.message ? s.message : `${s}`;
}
function Nt() {
  if (typeof globalThis < "u")
    return globalThis;
  if (typeof self < "u")
    return self;
  if (typeof window < "u")
    return window;
  if (typeof global < "u")
    return global;
  throw new Error("could not find global");
}
class Mt extends R {
  constructor(e) {
    if (super(), this._logger = e, typeof fetch > "u" || p.isNode) {
      const t = typeof __webpack_require__ == "function" ? __non_webpack_require__ : require;
      this._jar = new (t("tough-cookie")).CookieJar(), typeof fetch > "u" ? this._fetchType = t("node-fetch") : this._fetchType = fetch, this._fetchType = t("fetch-cookie")(this._fetchType, this._jar);
    } else
      this._fetchType = fetch.bind(Nt());
    if (typeof AbortController > "u") {
      const t = typeof __webpack_require__ == "function" ? __non_webpack_require__ : require;
      this._abortControllerType = t("abort-controller");
    } else
      this._abortControllerType = AbortController;
  }
  /** @inheritDoc */
  async send(e) {
    if (e.abortSignal && e.abortSignal.aborted)
      throw new y();
    if (!e.method)
      throw new Error("No method defined.");
    if (!e.url)
      throw new Error("No url defined.");
    const t = new this._abortControllerType();
    let n;
    e.abortSignal && (e.abortSignal.onabort = () => {
      t.abort(), n = new y();
    });
    let o = null;
    if (e.timeout) {
      const l = e.timeout;
      o = setTimeout(() => {
        t.abort(), this._logger.log(r.Warning, "Timeout from HTTP request."), n = new D();
      }, l);
    }
    e.content === "" && (e.content = void 0), e.content && (e.headers = e.headers || {}, k(e.content) ? e.headers["Content-Type"] = "application/octet-stream" : e.headers["Content-Type"] = "text/plain;charset=UTF-8");
    let i;
    try {
      i = await this._fetchType(e.url, {
        body: e.content,
        cache: "no-cache",
        credentials: e.withCredentials === !0 ? "include" : "same-origin",
        headers: {
          "X-Requested-With": "XMLHttpRequest",
          ...e.headers
        },
        method: e.method,
        mode: "cors",
        redirect: "follow",
        signal: t.signal
      });
    } catch (l) {
      throw n || (this._logger.log(r.Warning, `Error from HTTP request. ${l}.`), l);
    } finally {
      o && clearTimeout(o), e.abortSignal && (e.abortSignal.onabort = null);
    }
    if (!i.ok) {
      const l = await U(i, "text");
      throw new v(l || i.statusText, i.status);
    }
    const c = await U(i, e.responseType);
    return new z(i.status, i.statusText, c);
  }
  getCookieString(e) {
    let t = "";
    return p.isNode && this._jar && this._jar.getCookies(e, (n, o) => t = o.join("; ")), t;
  }
}
function U(s, e) {
  let t;
  switch (e) {
    case "arraybuffer":
      t = s.arrayBuffer();
      break;
    case "text":
      t = s.text();
      break;
    case "blob":
    case "document":
    case "json":
      throw new Error(`${e} is not supported.`);
    default:
      t = s.text();
      break;
  }
  return t;
}
class Dt extends R {
  constructor(e) {
    super(), this._logger = e;
  }
  /** @inheritDoc */
  send(e) {
    return e.abortSignal && e.abortSignal.aborted ? Promise.reject(new y()) : e.method ? e.url ? new Promise((t, n) => {
      const o = new XMLHttpRequest();
      o.open(e.method, e.url, !0), o.withCredentials = e.withCredentials === void 0 ? !0 : e.withCredentials, o.setRequestHeader("X-Requested-With", "XMLHttpRequest"), e.content === "" && (e.content = void 0), e.content && (k(e.content) ? o.setRequestHeader("Content-Type", "application/octet-stream") : o.setRequestHeader("Content-Type", "text/plain;charset=UTF-8"));
      const i = e.headers;
      i && Object.keys(i).forEach((a) => {
        o.setRequestHeader(a, i[a]);
      }), e.responseType && (o.responseType = e.responseType), e.abortSignal && (e.abortSignal.onabort = () => {
        o.abort(), n(new y());
      }), e.timeout && (o.timeout = e.timeout), o.onload = () => {
        e.abortSignal && (e.abortSignal.onabort = null), o.status >= 200 && o.status < 300 ? t(new z(o.status, o.statusText, o.response || o.responseText)) : n(new v(o.response || o.responseText || o.statusText, o.status));
      }, o.onerror = () => {
        this._logger.log(r.Warning, `Error from HTTP request. ${o.status}: ${o.statusText}.`), n(new v(o.statusText, o.status));
      }, o.ontimeout = () => {
        this._logger.log(r.Warning, "Timeout from HTTP request."), n(new D());
      }, o.send(e.content);
    }) : Promise.reject(new Error("No url defined.")) : Promise.reject(new Error("No method defined."));
  }
}
class xt extends R {
  /** Creates a new instance of the {@link @microsoft/signalr.DefaultHttpClient}, using the provided {@link @microsoft/signalr.ILogger} to log messages. */
  constructor(e) {
    if (super(), typeof fetch < "u" || p.isNode)
      this._httpClient = new Mt(e);
    else if (typeof XMLHttpRequest < "u")
      this._httpClient = new Dt(e);
    else
      throw new Error("No usable HttpClient found.");
  }
  /** @inheritDoc */
  send(e) {
    return e.abortSignal && e.abortSignal.aborted ? Promise.reject(new y()) : e.method ? e.url ? this._httpClient.send(e) : Promise.reject(new Error("No url defined.")) : Promise.reject(new Error("No method defined."));
  }
  getCookieString(e) {
    return this._httpClient.getCookieString(e);
  }
}
class w {
  static write(e) {
    return `${e}${w.RecordSeparator}`;
  }
  static parse(e) {
    if (e[e.length - 1] !== w.RecordSeparator)
      throw new Error("Message is incomplete.");
    const t = e.split(w.RecordSeparator);
    return t.pop(), t;
  }
}
w.RecordSeparatorCode = 30;
w.RecordSeparator = String.fromCharCode(w.RecordSeparatorCode);
class jt {
  // Handshake request is always JSON
  writeHandshakeRequest(e) {
    return w.write(JSON.stringify(e));
  }
  parseHandshakeResponse(e) {
    let t, n;
    if (k(e)) {
      const c = new Uint8Array(e), l = c.indexOf(w.RecordSeparatorCode);
      if (l === -1)
        throw new Error("Message is incomplete.");
      const h = l + 1;
      t = String.fromCharCode.apply(null, Array.prototype.slice.call(c.slice(0, h))), n = c.byteLength > h ? c.slice(h).buffer : null;
    } else {
      const c = e, l = c.indexOf(w.RecordSeparator);
      if (l === -1)
        throw new Error("Message is incomplete.");
      const h = l + 1;
      t = c.substring(0, h), n = c.length > h ? c.substring(h) : null;
    }
    const o = w.parse(t), i = JSON.parse(o[0]);
    if (i.type)
      throw new Error("Expected a handshake response from the server.");
    return [n, i];
  }
}
var u;
(function(s) {
  s[s.Invocation = 1] = "Invocation", s[s.StreamItem = 2] = "StreamItem", s[s.Completion = 3] = "Completion", s[s.StreamInvocation = 4] = "StreamInvocation", s[s.CancelInvocation = 5] = "CancelInvocation", s[s.Ping = 6] = "Ping", s[s.Close = 7] = "Close", s[s.Ack = 8] = "Ack", s[s.Sequence = 9] = "Sequence";
})(u || (u = {}));
class Lt {
  constructor() {
    this.observers = [];
  }
  next(e) {
    for (const t of this.observers)
      t.next(e);
  }
  error(e) {
    for (const t of this.observers)
      t.error && t.error(e);
  }
  complete() {
    for (const e of this.observers)
      e.complete && e.complete();
  }
  subscribe(e) {
    return this.observers.push(e), new Et(this, e);
  }
}
class Ht {
  constructor(e, t, n) {
    this._bufferSize = 1e5, this._messages = [], this._totalMessageCount = 0, this._waitForSequenceMessage = !1, this._nextReceivingSequenceId = 1, this._latestReceivedSequenceId = 0, this._bufferedByteCount = 0, this._reconnectInProgress = !1, this._protocol = e, this._connection = t, this._bufferSize = n;
  }
  async _send(e) {
    const t = this._protocol.writeMessage(e);
    let n = Promise.resolve();
    if (this._isInvocationMessage(e)) {
      this._totalMessageCount++;
      let o = () => {
      }, i = () => {
      };
      k(t) ? this._bufferedByteCount += t.byteLength : this._bufferedByteCount += t.length, this._bufferedByteCount >= this._bufferSize && (n = new Promise((a, c) => {
        o = a, i = c;
      })), this._messages.push(new Ut(t, this._totalMessageCount, o, i));
    }
    try {
      this._reconnectInProgress || await this._connection.send(t);
    } catch {
      this._disconnected();
    }
    await n;
  }
  _ack(e) {
    let t = -1;
    for (let n = 0; n < this._messages.length; n++) {
      const o = this._messages[n];
      if (o._id <= e.sequenceId)
        t = n, k(o._message) ? this._bufferedByteCount -= o._message.byteLength : this._bufferedByteCount -= o._message.length, o._resolver();
      else if (this._bufferedByteCount < this._bufferSize)
        o._resolver();
      else
        break;
    }
    t !== -1 && (this._messages = this._messages.slice(t + 1));
  }
  _shouldProcessMessage(e) {
    if (this._waitForSequenceMessage)
      return e.type !== u.Sequence ? !1 : (this._waitForSequenceMessage = !1, !0);
    if (!this._isInvocationMessage(e))
      return !0;
    const t = this._nextReceivingSequenceId;
    return this._nextReceivingSequenceId++, t <= this._latestReceivedSequenceId ? (t === this._latestReceivedSequenceId && this._ackTimer(), !1) : (this._latestReceivedSequenceId = t, this._ackTimer(), !0);
  }
  _resetSequence(e) {
    if (e.sequenceId > this._nextReceivingSequenceId) {
      this._connection.stop(new Error("Sequence ID greater than amount of messages we've received."));
      return;
    }
    this._nextReceivingSequenceId = e.sequenceId;
  }
  _disconnected() {
    this._reconnectInProgress = !0, this._waitForSequenceMessage = !0;
  }
  async _resend() {
    const e = this._messages.length !== 0 ? this._messages[0]._id : this._totalMessageCount + 1;
    await this._connection.send(this._protocol.writeMessage({ type: u.Sequence, sequenceId: e }));
    const t = this._messages;
    for (const n of t)
      await this._connection.send(n._message);
    this._reconnectInProgress = !1;
  }
  _dispose(e) {
    e ?? (e = new Error("Unable to reconnect to server."));
    for (const t of this._messages)
      t._rejector(e);
  }
  _isInvocationMessage(e) {
    switch (e.type) {
      case u.Invocation:
      case u.StreamItem:
      case u.Completion:
      case u.StreamInvocation:
      case u.CancelInvocation:
        return !0;
      case u.Close:
      case u.Sequence:
      case u.Ping:
      case u.Ack:
        return !1;
    }
  }
  _ackTimer() {
    this._ackTimerHandle === void 0 && (this._ackTimerHandle = setTimeout(async () => {
      try {
        this._reconnectInProgress || await this._connection.send(this._protocol.writeMessage({ type: u.Ack, sequenceId: this._latestReceivedSequenceId }));
      } catch {
      }
      clearTimeout(this._ackTimerHandle), this._ackTimerHandle = void 0;
    }, 1e3));
  }
}
class Ut {
  constructor(e, t, n, o) {
    this._message = e, this._id = t, this._resolver = n, this._rejector = o;
  }
}
const Bt = 30 * 1e3, Ot = 15 * 1e3, Wt = 1e5;
var f;
(function(s) {
  s.Disconnected = "Disconnected", s.Connecting = "Connecting", s.Connected = "Connected", s.Disconnecting = "Disconnecting", s.Reconnecting = "Reconnecting";
})(f || (f = {}));
class x {
  /** @internal */
  // Using a public static factory method means we can have a private constructor and an _internal_
  // create method that can be used by HubConnectionBuilder. An "internal" constructor would just
  // be stripped away and the '.d.ts' file would have no constructor, which is interpreted as a
  // public parameter-less constructor.
  static create(e, t, n, o, i, a, c) {
    return new x(e, t, n, o, i, a, c);
  }
  constructor(e, t, n, o, i, a, c) {
    this._nextKeepAlive = 0, this._freezeEventListener = () => {
      this._logger.log(r.Warning, "The page is being frozen, this will likely lead to the connection being closed and messages being lost. For more information see the docs at https://learn.microsoft.com/aspnet/core/signalr/javascript-client#bsleep");
    }, _.isRequired(e, "connection"), _.isRequired(t, "logger"), _.isRequired(n, "protocol"), this.serverTimeoutInMilliseconds = i ?? Bt, this.keepAliveIntervalInMilliseconds = a ?? Ot, this._statefulReconnectBufferSize = c ?? Wt, this._logger = t, this._protocol = n, this.connection = e, this._reconnectPolicy = o, this._handshakeProtocol = new jt(), this.connection.onreceive = (l) => this._processIncomingData(l), this.connection.onclose = (l) => this._connectionClosed(l), this._callbacks = {}, this._methods = {}, this._closedCallbacks = [], this._reconnectingCallbacks = [], this._reconnectedCallbacks = [], this._invocationId = 0, this._receivedHandshakeResponse = !1, this._connectionState = f.Disconnected, this._connectionStarted = !1, this._cachedPingMessage = this._protocol.writeMessage({ type: u.Ping });
  }
  /** Indicates the state of the {@link HubConnection} to the server. */
  get state() {
    return this._connectionState;
  }
  /** Represents the connection id of the {@link HubConnection} on the server. The connection id will be null when the connection is either
   *  in the disconnected state or if the negotiation step was skipped.
   */
  get connectionId() {
    return this.connection && this.connection.connectionId || null;
  }
  /** Indicates the url of the {@link HubConnection} to the server. */
  get baseUrl() {
    return this.connection.baseUrl || "";
  }
  /**
   * Sets a new url for the HubConnection. Note that the url can only be changed when the connection is in either the Disconnected or
   * Reconnecting states.
   * @param {string} url The url to connect to.
   */
  set baseUrl(e) {
    if (this._connectionState !== f.Disconnected && this._connectionState !== f.Reconnecting)
      throw new Error("The HubConnection must be in the Disconnected or Reconnecting state to change the url.");
    if (!e)
      throw new Error("The HubConnection url must be a valid url.");
    this.connection.baseUrl = e;
  }
  /** Starts the connection.
   *
   * @returns {Promise<void>} A Promise that resolves when the connection has been successfully established, or rejects with an error.
   */
  start() {
    return this._startPromise = this._startWithStateTransitions(), this._startPromise;
  }
  async _startWithStateTransitions() {
    if (this._connectionState !== f.Disconnected)
      return Promise.reject(new Error("Cannot start a HubConnection that is not in the 'Disconnected' state."));
    this._connectionState = f.Connecting, this._logger.log(r.Debug, "Starting HubConnection.");
    try {
      await this._startInternal(), p.isBrowser && window.document.addEventListener("freeze", this._freezeEventListener), this._connectionState = f.Connected, this._connectionStarted = !0, this._logger.log(r.Debug, "HubConnection connected successfully.");
    } catch (e) {
      return this._connectionState = f.Disconnected, this._logger.log(r.Debug, `HubConnection failed to start successfully because of error '${e}'.`), Promise.reject(e);
    }
  }
  async _startInternal() {
    this._stopDuringStartError = void 0, this._receivedHandshakeResponse = !1;
    const e = new Promise((t, n) => {
      this._handshakeResolver = t, this._handshakeRejecter = n;
    });
    await this.connection.start(this._protocol.transferFormat);
    try {
      let t = this._protocol.version;
      this.connection.features.reconnect || (t = 1);
      const n = {
        protocol: this._protocol.name,
        version: t
      };
      if (this._logger.log(r.Debug, "Sending handshake request."), await this._sendMessage(this._handshakeProtocol.writeHandshakeRequest(n)), this._logger.log(r.Information, `Using HubProtocol '${this._protocol.name}'.`), this._cleanupTimeout(), this._resetTimeoutPeriod(), this._resetKeepAliveInterval(), await e, this._stopDuringStartError)
        throw this._stopDuringStartError;
      (this.connection.features.reconnect || !1) && (this._messageBuffer = new Ht(this._protocol, this.connection, this._statefulReconnectBufferSize), this.connection.features.disconnected = this._messageBuffer._disconnected.bind(this._messageBuffer), this.connection.features.resend = () => {
        if (this._messageBuffer)
          return this._messageBuffer._resend();
      }), this.connection.features.inherentKeepAlive || await this._sendMessage(this._cachedPingMessage);
    } catch (t) {
      throw this._logger.log(r.Debug, `Hub handshake failed with error '${t}' during start(). Stopping HubConnection.`), this._cleanupTimeout(), this._cleanupPingTimer(), await this.connection.stop(t), t;
    }
  }
  /** Stops the connection.
   *
   * @returns {Promise<void>} A Promise that resolves when the connection has been successfully terminated, or rejects with an error.
   */
  async stop() {
    const e = this._startPromise;
    this.connection.features.reconnect = !1, this._stopPromise = this._stopInternal(), await this._stopPromise;
    try {
      await e;
    } catch {
    }
  }
  _stopInternal(e) {
    if (this._connectionState === f.Disconnected)
      return this._logger.log(r.Debug, `Call to HubConnection.stop(${e}) ignored because it is already in the disconnected state.`), Promise.resolve();
    if (this._connectionState === f.Disconnecting)
      return this._logger.log(r.Debug, `Call to HttpConnection.stop(${e}) ignored because the connection is already in the disconnecting state.`), this._stopPromise;
    const t = this._connectionState;
    return this._connectionState = f.Disconnecting, this._logger.log(r.Debug, "Stopping HubConnection."), this._reconnectDelayHandle ? (this._logger.log(r.Debug, "Connection stopped during reconnect delay. Done reconnecting."), clearTimeout(this._reconnectDelayHandle), this._reconnectDelayHandle = void 0, this._completeClose(), Promise.resolve()) : (t === f.Connected && this._sendCloseMessage(), this._cleanupTimeout(), this._cleanupPingTimer(), this._stopDuringStartError = e || new y("The connection was stopped before the hub handshake could complete."), this.connection.stop(e));
  }
  async _sendCloseMessage() {
    try {
      await this._sendWithProtocol(this._createCloseMessage());
    } catch {
    }
  }
  /** Invokes a streaming hub method on the server using the specified name and arguments.
   *
   * @typeparam T The type of the items returned by the server.
   * @param {string} methodName The name of the server method to invoke.
   * @param {any[]} args The arguments used to invoke the server method.
   * @returns {IStreamResult<T>} An object that yields results from the server as they are received.
   */
  stream(e, ...t) {
    const [n, o] = this._replaceStreamingParams(t), i = this._createStreamInvocation(e, t, o);
    let a;
    const c = new Lt();
    return c.cancelCallback = () => {
      const l = this._createCancelInvocation(i.invocationId);
      return delete this._callbacks[i.invocationId], a.then(() => this._sendWithProtocol(l));
    }, this._callbacks[i.invocationId] = (l, h) => {
      if (h) {
        c.error(h);
        return;
      } else
        l && (l.type === u.Completion ? l.error ? c.error(new Error(l.error)) : c.complete() : c.next(l.item));
    }, a = this._sendWithProtocol(i).catch((l) => {
      c.error(l), delete this._callbacks[i.invocationId];
    }), this._launchStreams(n, a), c;
  }
  _sendMessage(e) {
    return this._resetKeepAliveInterval(), this.connection.send(e);
  }
  /**
   * Sends a js object to the server.
   * @param message The js object to serialize and send.
   */
  _sendWithProtocol(e) {
    return this._messageBuffer ? this._messageBuffer._send(e) : this._sendMessage(this._protocol.writeMessage(e));
  }
  /** Invokes a hub method on the server using the specified name and arguments. Does not wait for a response from the receiver.
   *
   * The Promise returned by this method resolves when the client has sent the invocation to the server. The server may still
   * be processing the invocation.
   *
   * @param {string} methodName The name of the server method to invoke.
   * @param {any[]} args The arguments used to invoke the server method.
   * @returns {Promise<void>} A Promise that resolves when the invocation has been successfully sent, or rejects with an error.
   */
  send(e, ...t) {
    const [n, o] = this._replaceStreamingParams(t), i = this._sendWithProtocol(this._createInvocation(e, t, !0, o));
    return this._launchStreams(n, i), i;
  }
  /** Invokes a hub method on the server using the specified name and arguments.
   *
   * The Promise returned by this method resolves when the server indicates it has finished invoking the method. When the promise
   * resolves, the server has finished invoking the method. If the server method returns a result, it is produced as the result of
   * resolving the Promise.
   *
   * @typeparam T The expected return type.
   * @param {string} methodName The name of the server method to invoke.
   * @param {any[]} args The arguments used to invoke the server method.
   * @returns {Promise<T>} A Promise that resolves with the result of the server method (if any), or rejects with an error.
   */
  invoke(e, ...t) {
    const [n, o] = this._replaceStreamingParams(t), i = this._createInvocation(e, t, !1, o);
    return new Promise((c, l) => {
      this._callbacks[i.invocationId] = (d, S) => {
        if (S) {
          l(S);
          return;
        } else
          d && (d.type === u.Completion ? d.error ? l(new Error(d.error)) : c(d.result) : l(new Error(`Unexpected message type: ${d.type}`)));
      };
      const h = this._sendWithProtocol(i).catch((d) => {
        l(d), delete this._callbacks[i.invocationId];
      });
      this._launchStreams(n, h);
    });
  }
  on(e, t) {
    !e || !t || (e = e.toLowerCase(), this._methods[e] || (this._methods[e] = []), this._methods[e].indexOf(t) === -1 && this._methods[e].push(t));
  }
  off(e, t) {
    if (!e)
      return;
    e = e.toLowerCase();
    const n = this._methods[e];
    if (n)
      if (t) {
        const o = n.indexOf(t);
        o !== -1 && (n.splice(o, 1), n.length === 0 && delete this._methods[e]);
      } else
        delete this._methods[e];
  }
  /** Registers a handler that will be invoked when the connection is closed.
   *
   * @param {Function} callback The handler that will be invoked when the connection is closed. Optionally receives a single argument containing the error that caused the connection to close (if any).
   */
  onclose(e) {
    e && this._closedCallbacks.push(e);
  }
  /** Registers a handler that will be invoked when the connection starts reconnecting.
   *
   * @param {Function} callback The handler that will be invoked when the connection starts reconnecting. Optionally receives a single argument containing the error that caused the connection to start reconnecting (if any).
   */
  onreconnecting(e) {
    e && this._reconnectingCallbacks.push(e);
  }
  /** Registers a handler that will be invoked when the connection successfully reconnects.
   *
   * @param {Function} callback The handler that will be invoked when the connection successfully reconnects.
   */
  onreconnected(e) {
    e && this._reconnectedCallbacks.push(e);
  }
  _processIncomingData(e) {
    if (this._cleanupTimeout(), this._receivedHandshakeResponse || (e = this._processHandshakeResponse(e), this._receivedHandshakeResponse = !0), e) {
      const t = this._protocol.parseMessages(e, this._logger);
      for (const n of t)
        if (!(this._messageBuffer && !this._messageBuffer._shouldProcessMessage(n)))
          switch (n.type) {
            case u.Invocation:
              this._invokeClientMethod(n).catch((o) => {
                this._logger.log(r.Error, `Invoke client method threw error: ${N(o)}`);
              });
              break;
            case u.StreamItem:
            case u.Completion: {
              const o = this._callbacks[n.invocationId];
              if (o) {
                n.type === u.Completion && delete this._callbacks[n.invocationId];
                try {
                  o(n);
                } catch (i) {
                  this._logger.log(r.Error, `Stream callback threw error: ${N(i)}`);
                }
              }
              break;
            }
            case u.Ping:
              break;
            case u.Close: {
              this._logger.log(r.Information, "Close message received from server.");
              const o = n.error ? new Error("Server returned an error on close: " + n.error) : void 0;
              n.allowReconnect === !0 ? this.connection.stop(o) : this._stopPromise = this._stopInternal(o);
              break;
            }
            case u.Ack:
              this._messageBuffer && this._messageBuffer._ack(n);
              break;
            case u.Sequence:
              this._messageBuffer && this._messageBuffer._resetSequence(n);
              break;
            default:
              this._logger.log(r.Warning, `Invalid message type: ${n.type}.`);
              break;
          }
    }
    this._resetTimeoutPeriod();
  }
  _processHandshakeResponse(e) {
    let t, n;
    try {
      [n, t] = this._handshakeProtocol.parseHandshakeResponse(e);
    } catch (o) {
      const i = "Error parsing handshake response: " + o;
      this._logger.log(r.Error, i);
      const a = new Error(i);
      throw this._handshakeRejecter(a), a;
    }
    if (t.error) {
      const o = "Server returned handshake error: " + t.error;
      this._logger.log(r.Error, o);
      const i = new Error(o);
      throw this._handshakeRejecter(i), i;
    } else
      this._logger.log(r.Debug, "Server handshake complete.");
    return this._handshakeResolver(), n;
  }
  _resetKeepAliveInterval() {
    this.connection.features.inherentKeepAlive || (this._nextKeepAlive = (/* @__PURE__ */ new Date()).getTime() + this.keepAliveIntervalInMilliseconds, this._cleanupPingTimer());
  }
  _resetTimeoutPeriod() {
    if ((!this.connection.features || !this.connection.features.inherentKeepAlive) && (this._timeoutHandle = setTimeout(() => this.serverTimeout(), this.serverTimeoutInMilliseconds), this._pingServerHandle === void 0)) {
      let e = this._nextKeepAlive - (/* @__PURE__ */ new Date()).getTime();
      e < 0 && (e = 0), this._pingServerHandle = setTimeout(async () => {
        if (this._connectionState === f.Connected)
          try {
            await this._sendMessage(this._cachedPingMessage);
          } catch {
            this._cleanupPingTimer();
          }
      }, e);
    }
  }
  // eslint-disable-next-line @typescript-eslint/naming-convention
  serverTimeout() {
    this.connection.stop(new Error("Server timeout elapsed without receiving a message from the server."));
  }
  async _invokeClientMethod(e) {
    const t = e.target.toLowerCase(), n = this._methods[t];
    if (!n) {
      this._logger.log(r.Warning, `No client method with the name '${t}' found.`), e.invocationId && (this._logger.log(r.Warning, `No result given for '${t}' method and invocation ID '${e.invocationId}'.`), await this._sendWithProtocol(this._createCompletionMessage(e.invocationId, "Client didn't provide a result.", null)));
      return;
    }
    const o = n.slice(), i = !!e.invocationId;
    let a, c, l;
    for (const h of o)
      try {
        const d = a;
        a = await h.apply(this, e.arguments), i && a && d && (this._logger.log(r.Error, `Multiple results provided for '${t}'. Sending error to server.`), l = this._createCompletionMessage(e.invocationId, "Client provided multiple results.", null)), c = void 0;
      } catch (d) {
        c = d, this._logger.log(r.Error, `A callback for the method '${t}' threw error '${d}'.`);
      }
    l ? await this._sendWithProtocol(l) : i ? (c ? l = this._createCompletionMessage(e.invocationId, `${c}`, null) : a !== void 0 ? l = this._createCompletionMessage(e.invocationId, null, a) : (this._logger.log(r.Warning, `No result given for '${t}' method and invocation ID '${e.invocationId}'.`), l = this._createCompletionMessage(e.invocationId, "Client didn't provide a result.", null)), await this._sendWithProtocol(l)) : a && this._logger.log(r.Error, `Result given for '${t}' method but server is not expecting a result.`);
  }
  _connectionClosed(e) {
    this._logger.log(r.Debug, `HubConnection.connectionClosed(${e}) called while in state ${this._connectionState}.`), this._stopDuringStartError = this._stopDuringStartError || e || new y("The underlying connection was closed before the hub handshake could complete."), this._handshakeResolver && this._handshakeResolver(), this._cancelCallbacksWithError(e || new Error("Invocation canceled due to the underlying connection being closed.")), this._cleanupTimeout(), this._cleanupPingTimer(), this._connectionState === f.Disconnecting ? this._completeClose(e) : this._connectionState === f.Connected && this._reconnectPolicy ? this._reconnect(e) : this._connectionState === f.Connected && this._completeClose(e);
  }
  _completeClose(e) {
    if (this._connectionStarted) {
      this._connectionState = f.Disconnected, this._connectionStarted = !1, this._messageBuffer && (this._messageBuffer._dispose(e ?? new Error("Connection closed.")), this._messageBuffer = void 0), p.isBrowser && window.document.removeEventListener("freeze", this._freezeEventListener);
      try {
        this._closedCallbacks.forEach((t) => t.apply(this, [e]));
      } catch (t) {
        this._logger.log(r.Error, `An onclose callback called with error '${e}' threw error '${t}'.`);
      }
    }
  }
  async _reconnect(e) {
    const t = Date.now();
    let n = 0, o = e !== void 0 ? e : new Error("Attempting to reconnect due to a unknown error."), i = this._getNextRetryDelay(n++, 0, o);
    if (i === null) {
      this._logger.log(r.Debug, "Connection not reconnecting because the IRetryPolicy returned null on the first reconnect attempt."), this._completeClose(e);
      return;
    }
    if (this._connectionState = f.Reconnecting, e ? this._logger.log(r.Information, `Connection reconnecting because of error '${e}'.`) : this._logger.log(r.Information, "Connection reconnecting."), this._reconnectingCallbacks.length !== 0) {
      try {
        this._reconnectingCallbacks.forEach((a) => a.apply(this, [e]));
      } catch (a) {
        this._logger.log(r.Error, `An onreconnecting callback called with error '${e}' threw error '${a}'.`);
      }
      if (this._connectionState !== f.Reconnecting) {
        this._logger.log(r.Debug, "Connection left the reconnecting state in onreconnecting callback. Done reconnecting.");
        return;
      }
    }
    for (; i !== null; ) {
      if (this._logger.log(r.Information, `Reconnect attempt number ${n} will start in ${i} ms.`), await new Promise((a) => {
        this._reconnectDelayHandle = setTimeout(a, i);
      }), this._reconnectDelayHandle = void 0, this._connectionState !== f.Reconnecting) {
        this._logger.log(r.Debug, "Connection left the reconnecting state during reconnect delay. Done reconnecting.");
        return;
      }
      try {
        if (await this._startInternal(), this._connectionState = f.Connected, this._logger.log(r.Information, "HubConnection reconnected successfully."), this._reconnectedCallbacks.length !== 0)
          try {
            this._reconnectedCallbacks.forEach((a) => a.apply(this, [this.connection.connectionId]));
          } catch (a) {
            this._logger.log(r.Error, `An onreconnected callback called with connectionId '${this.connection.connectionId}; threw error '${a}'.`);
          }
        return;
      } catch (a) {
        if (this._logger.log(r.Information, `Reconnect attempt failed because of error '${a}'.`), this._connectionState !== f.Reconnecting) {
          this._logger.log(r.Debug, `Connection moved to the '${this._connectionState}' from the reconnecting state during reconnect attempt. Done reconnecting.`), this._connectionState === f.Disconnecting && this._completeClose();
          return;
        }
        o = a instanceof Error ? a : new Error(a.toString()), i = this._getNextRetryDelay(n++, Date.now() - t, o);
      }
    }
    this._logger.log(r.Information, `Reconnect retries have been exhausted after ${Date.now() - t} ms and ${n} failed attempts. Connection disconnecting.`), this._completeClose();
  }
  _getNextRetryDelay(e, t, n) {
    try {
      return this._reconnectPolicy.nextRetryDelayInMilliseconds({
        elapsedMilliseconds: t,
        previousRetryCount: e,
        retryReason: n
      });
    } catch (o) {
      return this._logger.log(r.Error, `IRetryPolicy.nextRetryDelayInMilliseconds(${e}, ${t}) threw error '${o}'.`), null;
    }
  }
  _cancelCallbacksWithError(e) {
    const t = this._callbacks;
    this._callbacks = {}, Object.keys(t).forEach((n) => {
      const o = t[n];
      try {
        o(null, e);
      } catch (i) {
        this._logger.log(r.Error, `Stream 'error' callback called with '${e}' threw error: ${N(i)}`);
      }
    });
  }
  _cleanupPingTimer() {
    this._pingServerHandle && (clearTimeout(this._pingServerHandle), this._pingServerHandle = void 0);
  }
  _cleanupTimeout() {
    this._timeoutHandle && clearTimeout(this._timeoutHandle);
  }
  _createInvocation(e, t, n, o) {
    if (n)
      return o.length !== 0 ? {
        arguments: t,
        streamIds: o,
        target: e,
        type: u.Invocation
      } : {
        arguments: t,
        target: e,
        type: u.Invocation
      };
    {
      const i = this._invocationId;
      return this._invocationId++, o.length !== 0 ? {
        arguments: t,
        invocationId: i.toString(),
        streamIds: o,
        target: e,
        type: u.Invocation
      } : {
        arguments: t,
        invocationId: i.toString(),
        target: e,
        type: u.Invocation
      };
    }
  }
  _launchStreams(e, t) {
    if (e.length !== 0) {
      t || (t = Promise.resolve());
      for (const n in e)
        e[n].subscribe({
          complete: () => {
            t = t.then(() => this._sendWithProtocol(this._createCompletionMessage(n)));
          },
          error: (o) => {
            let i;
            o instanceof Error ? i = o.message : o && o.toString ? i = o.toString() : i = "Unknown error", t = t.then(() => this._sendWithProtocol(this._createCompletionMessage(n, i)));
          },
          next: (o) => {
            t = t.then(() => this._sendWithProtocol(this._createStreamItemMessage(n, o)));
          }
        });
    }
  }
  _replaceStreamingParams(e) {
    const t = [], n = [];
    for (let o = 0; o < e.length; o++) {
      const i = e[o];
      if (this._isObservable(i)) {
        const a = this._invocationId;
        this._invocationId++, t[a] = i, n.push(a.toString()), e.splice(o, 1);
      }
    }
    return [t, n];
  }
  _isObservable(e) {
    return e && e.subscribe && typeof e.subscribe == "function";
  }
  _createStreamInvocation(e, t, n) {
    const o = this._invocationId;
    return this._invocationId++, n.length !== 0 ? {
      arguments: t,
      invocationId: o.toString(),
      streamIds: n,
      target: e,
      type: u.StreamInvocation
    } : {
      arguments: t,
      invocationId: o.toString(),
      target: e,
      type: u.StreamInvocation
    };
  }
  _createCancelInvocation(e) {
    return {
      invocationId: e,
      type: u.CancelInvocation
    };
  }
  _createStreamItemMessage(e, t) {
    return {
      invocationId: e,
      item: t,
      type: u.StreamItem
    };
  }
  _createCompletionMessage(e, t, n) {
    return t ? {
      error: t,
      invocationId: e,
      type: u.Completion
    } : {
      invocationId: e,
      result: n,
      type: u.Completion
    };
  }
  _createCloseMessage() {
    return { type: u.Close };
  }
}
const Ft = [0, 2e3, 1e4, 3e4, null];
class B {
  constructor(e) {
    this._retryDelays = e !== void 0 ? [...e, null] : Ft;
  }
  nextRetryDelayInMilliseconds(e) {
    return this._retryDelays[e.previousRetryCount];
  }
}
class C {
}
C.Authorization = "Authorization";
C.Cookie = "Cookie";
class zt extends R {
  constructor(e, t) {
    super(), this._innerClient = e, this._accessTokenFactory = t;
  }
  async send(e) {
    let t = !0;
    this._accessTokenFactory && (!this._accessToken || e.url && e.url.indexOf("/negotiate?") > 0) && (t = !1, this._accessToken = await this._accessTokenFactory()), this._setAuthorizationHeader(e);
    const n = await this._innerClient.send(e);
    return t && n.statusCode === 401 && this._accessTokenFactory ? (this._accessToken = await this._accessTokenFactory(), this._setAuthorizationHeader(e), await this._innerClient.send(e)) : n;
  }
  _setAuthorizationHeader(e) {
    e.headers || (e.headers = {}), this._accessToken ? e.headers[C.Authorization] = `Bearer ${this._accessToken}` : this._accessTokenFactory && e.headers[C.Authorization] && delete e.headers[C.Authorization];
  }
  getCookieString(e) {
    return this._innerClient.getCookieString(e);
  }
}
var m;
(function(s) {
  s[s.None = 0] = "None", s[s.WebSockets = 1] = "WebSockets", s[s.ServerSentEvents = 2] = "ServerSentEvents", s[s.LongPolling = 4] = "LongPolling";
})(m || (m = {}));
var b;
(function(s) {
  s[s.Text = 1] = "Text", s[s.Binary = 2] = "Binary";
})(b || (b = {}));
class qt {
  constructor() {
    this._isAborted = !1, this.onabort = null;
  }
  abort() {
    this._isAborted || (this._isAborted = !0, this.onabort && this.onabort());
  }
  get signal() {
    return this;
  }
  get aborted() {
    return this._isAborted;
  }
}
class O {
  // This is an internal type, not exported from 'index' so this is really just internal.
  get pollAborted() {
    return this._pollAbort.aborted;
  }
  constructor(e, t, n) {
    this._httpClient = e, this._logger = t, this._pollAbort = new qt(), this._options = n, this._running = !1, this.onreceive = null, this.onclose = null;
  }
  async connect(e, t) {
    if (_.isRequired(e, "url"), _.isRequired(t, "transferFormat"), _.isIn(t, b, "transferFormat"), this._url = e, this._logger.log(r.Trace, "(LongPolling transport) Connecting."), t === b.Binary && typeof XMLHttpRequest < "u" && typeof new XMLHttpRequest().responseType != "string")
      throw new Error("Binary protocols over XmlHttpRequest not implementing advanced features are not supported.");
    const [n, o] = T(), i = { [n]: o, ...this._options.headers }, a = {
      abortSignal: this._pollAbort.signal,
      headers: i,
      timeout: 1e5,
      withCredentials: this._options.withCredentials
    };
    t === b.Binary && (a.responseType = "arraybuffer");
    const c = `${e}&_=${Date.now()}`;
    this._logger.log(r.Trace, `(LongPolling transport) polling: ${c}.`);
    const l = await this._httpClient.get(c, a);
    l.statusCode !== 200 ? (this._logger.log(r.Error, `(LongPolling transport) Unexpected response code: ${l.statusCode}.`), this._closeError = new v(l.statusText || "", l.statusCode), this._running = !1) : this._running = !0, this._receiving = this._poll(this._url, a);
  }
  async _poll(e, t) {
    try {
      for (; this._running; )
        try {
          const n = `${e}&_=${Date.now()}`;
          this._logger.log(r.Trace, `(LongPolling transport) polling: ${n}.`);
          const o = await this._httpClient.get(n, t);
          o.statusCode === 204 ? (this._logger.log(r.Information, "(LongPolling transport) Poll terminated by server."), this._running = !1) : o.statusCode !== 200 ? (this._logger.log(r.Error, `(LongPolling transport) Unexpected response code: ${o.statusCode}.`), this._closeError = new v(o.statusText || "", o.statusCode), this._running = !1) : o.content ? (this._logger.log(r.Trace, `(LongPolling transport) data received. ${$(o.content, this._options.logMessageContent)}.`), this.onreceive && this.onreceive(o.content)) : this._logger.log(r.Trace, "(LongPolling transport) Poll timed out, reissuing.");
        } catch (n) {
          this._running ? n instanceof D ? this._logger.log(r.Trace, "(LongPolling transport) Poll timed out, reissuing.") : (this._closeError = n, this._running = !1) : this._logger.log(r.Trace, `(LongPolling transport) Poll errored after shutdown: ${n.message}`);
        }
    } finally {
      this._logger.log(r.Trace, "(LongPolling transport) Polling complete."), this.pollAborted || this._raiseOnClose();
    }
  }
  async send(e) {
    return this._running ? q(this._logger, "LongPolling", this._httpClient, this._url, e, this._options) : Promise.reject(new Error("Cannot send until the transport is connected"));
  }
  async stop() {
    this._logger.log(r.Trace, "(LongPolling transport) Stopping polling."), this._running = !1, this._pollAbort.abort();
    try {
      await this._receiving, this._logger.log(r.Trace, `(LongPolling transport) sending DELETE request to ${this._url}.`);
      const e = {}, [t, n] = T();
      e[t] = n;
      const o = {
        headers: { ...e, ...this._options.headers },
        timeout: this._options.timeout,
        withCredentials: this._options.withCredentials
      };
      let i;
      try {
        await this._httpClient.delete(this._url, o);
      } catch (a) {
        i = a;
      }
      i ? i instanceof v && (i.statusCode === 404 ? this._logger.log(r.Trace, "(LongPolling transport) A 404 response was returned from sending a DELETE request.") : this._logger.log(r.Trace, `(LongPolling transport) Error sending a DELETE request: ${i}`)) : this._logger.log(r.Trace, "(LongPolling transport) DELETE request accepted.");
    } finally {
      this._logger.log(r.Trace, "(LongPolling transport) Stop finished."), this._raiseOnClose();
    }
  }
  _raiseOnClose() {
    if (this.onclose) {
      let e = "(LongPolling transport) Firing onclose event.";
      this._closeError && (e += " Error: " + this._closeError), this._logger.log(r.Trace, e), this.onclose(this._closeError);
    }
  }
}
class Jt {
  constructor(e, t, n, o) {
    this._httpClient = e, this._accessToken = t, this._logger = n, this._options = o, this.onreceive = null, this.onclose = null;
  }
  async connect(e, t) {
    return _.isRequired(e, "url"), _.isRequired(t, "transferFormat"), _.isIn(t, b, "transferFormat"), this._logger.log(r.Trace, "(SSE transport) Connecting."), this._url = e, this._accessToken && (e += (e.indexOf("?") < 0 ? "?" : "&") + `access_token=${encodeURIComponent(this._accessToken)}`), new Promise((n, o) => {
      let i = !1;
      if (t !== b.Text) {
        o(new Error("The Server-Sent Events transport only supports the 'Text' transfer format"));
        return;
      }
      let a;
      if (p.isBrowser || p.isWebWorker)
        a = new this._options.EventSource(e, { withCredentials: this._options.withCredentials });
      else {
        const c = this._httpClient.getCookieString(e), l = {};
        l.Cookie = c;
        const [h, d] = T();
        l[h] = d, a = new this._options.EventSource(e, { withCredentials: this._options.withCredentials, headers: { ...l, ...this._options.headers } });
      }
      try {
        a.onmessage = (c) => {
          if (this.onreceive)
            try {
              this._logger.log(r.Trace, `(SSE transport) data received. ${$(c.data, this._options.logMessageContent)}.`), this.onreceive(c.data);
            } catch (l) {
              this._close(l);
              return;
            }
        }, a.onerror = (c) => {
          i ? this._close() : o(new Error("EventSource failed to connect. The connection could not be found on the server, either the connection ID is not present on the server, or a proxy is refusing/buffering the connection. If you have multiple servers check that sticky sessions are enabled."));
        }, a.onopen = () => {
          this._logger.log(r.Information, `SSE connected to ${this._url}`), this._eventSource = a, i = !0, n();
        };
      } catch (c) {
        o(c);
        return;
      }
    });
  }
  async send(e) {
    return this._eventSource ? q(this._logger, "SSE", this._httpClient, this._url, e, this._options) : Promise.reject(new Error("Cannot send until the transport is connected"));
  }
  stop() {
    return this._close(), Promise.resolve();
  }
  _close(e) {
    this._eventSource && (this._eventSource.close(), this._eventSource = void 0, this.onclose && this.onclose(e));
  }
}
class Zt {
  constructor(e, t, n, o, i, a) {
    this._logger = n, this._accessTokenFactory = t, this._logMessageContent = o, this._webSocketConstructor = i, this._httpClient = e, this.onreceive = null, this.onclose = null, this._headers = a;
  }
  async connect(e, t) {
    _.isRequired(e, "url"), _.isRequired(t, "transferFormat"), _.isIn(t, b, "transferFormat"), this._logger.log(r.Trace, "(WebSockets transport) Connecting.");
    let n;
    return this._accessTokenFactory && (n = await this._accessTokenFactory()), new Promise((o, i) => {
      e = e.replace(/^http/, "ws");
      let a;
      const c = this._httpClient.getCookieString(e);
      let l = !1;
      if (p.isNode || p.isReactNative) {
        const h = {}, [d, S] = T();
        h[d] = S, n && (h[C.Authorization] = `Bearer ${n}`), c && (h[C.Cookie] = c), a = new this._webSocketConstructor(e, void 0, {
          headers: { ...h, ...this._headers }
        });
      } else
        n && (e += (e.indexOf("?") < 0 ? "?" : "&") + `access_token=${encodeURIComponent(n)}`);
      a || (a = new this._webSocketConstructor(e)), t === b.Binary && (a.binaryType = "arraybuffer"), a.onopen = (h) => {
        this._logger.log(r.Information, `WebSocket connected to ${e}.`), this._webSocket = a, l = !0, o();
      }, a.onerror = (h) => {
        let d = null;
        typeof ErrorEvent < "u" && h instanceof ErrorEvent ? d = h.error : d = "There was an error with the transport", this._logger.log(r.Information, `(WebSockets transport) ${d}.`);
      }, a.onmessage = (h) => {
        if (this._logger.log(r.Trace, `(WebSockets transport) data received. ${$(h.data, this._logMessageContent)}.`), this.onreceive)
          try {
            this.onreceive(h.data);
          } catch (d) {
            this._close(d);
            return;
          }
      }, a.onclose = (h) => {
        if (l)
          this._close(h);
        else {
          let d = null;
          typeof ErrorEvent < "u" && h instanceof ErrorEvent ? d = h.error : d = "WebSocket failed to connect. The connection could not be found on the server, either the endpoint may not be a SignalR endpoint, the connection ID is not present on the server, or there is a proxy blocking WebSockets. If you have multiple servers check that sticky sessions are enabled.", i(new Error(d));
        }
      };
    });
  }
  send(e) {
    return this._webSocket && this._webSocket.readyState === this._webSocketConstructor.OPEN ? (this._logger.log(r.Trace, `(WebSockets transport) sending data. ${$(e, this._logMessageContent)}.`), this._webSocket.send(e), Promise.resolve()) : Promise.reject("WebSocket is not in the OPEN state");
  }
  stop() {
    return this._webSocket && this._close(void 0), Promise.resolve();
  }
  _close(e) {
    this._webSocket && (this._webSocket.onclose = () => {
    }, this._webSocket.onmessage = () => {
    }, this._webSocket.onerror = () => {
    }, this._webSocket.close(), this._webSocket = void 0), this._logger.log(r.Trace, "(WebSockets transport) socket closed."), this.onclose && (this._isCloseEvent(e) && (e.wasClean === !1 || e.code !== 1e3) ? this.onclose(new Error(`WebSocket closed with status code: ${e.code} (${e.reason || "no reason given"}).`)) : e instanceof Error ? this.onclose(e) : this.onclose());
  }
  _isCloseEvent(e) {
    return e && typeof e.wasClean == "boolean" && typeof e.code == "number";
  }
}
const W = 100;
class Vt {
  constructor(e, t = {}) {
    if (this._stopPromiseResolver = () => {
    }, this.features = {}, this._negotiateVersion = 1, _.isRequired(e, "url"), this._logger = It(t.logger), this.baseUrl = this._resolveUrl(e), t = t || {}, t.logMessageContent = t.logMessageContent === void 0 ? !1 : t.logMessageContent, typeof t.withCredentials == "boolean" || t.withCredentials === void 0)
      t.withCredentials = t.withCredentials === void 0 ? !0 : t.withCredentials;
    else
      throw new Error("withCredentials option was not a 'boolean' or 'undefined' value");
    t.timeout = t.timeout === void 0 ? 100 * 1e3 : t.timeout;
    let n = null, o = null;
    if (p.isNode && typeof require < "u") {
      const i = typeof __webpack_require__ == "function" ? __non_webpack_require__ : require;
      n = i("ws"), o = i("eventsource");
    }
    !p.isNode && typeof WebSocket < "u" && !t.WebSocket ? t.WebSocket = WebSocket : p.isNode && !t.WebSocket && n && (t.WebSocket = n), !p.isNode && typeof EventSource < "u" && !t.EventSource ? t.EventSource = EventSource : p.isNode && !t.EventSource && typeof o < "u" && (t.EventSource = o), this._httpClient = new zt(t.httpClient || new xt(this._logger), t.accessTokenFactory), this._connectionState = "Disconnected", this._connectionStarted = !1, this._options = t, this.onreceive = null, this.onclose = null;
  }
  async start(e) {
    if (e = e || b.Binary, _.isIn(e, b, "transferFormat"), this._logger.log(r.Debug, `Starting connection with transfer format '${b[e]}'.`), this._connectionState !== "Disconnected")
      return Promise.reject(new Error("Cannot start an HttpConnection that is not in the 'Disconnected' state."));
    if (this._connectionState = "Connecting", this._startInternalPromise = this._startInternal(e), await this._startInternalPromise, this._connectionState === "Disconnecting") {
      const t = "Failed to start the HttpConnection before stop() was called.";
      return this._logger.log(r.Error, t), await this._stopPromise, Promise.reject(new y(t));
    } else if (this._connectionState !== "Connected") {
      const t = "HttpConnection.startInternal completed gracefully but didn't enter the connection into the connected state!";
      return this._logger.log(r.Error, t), Promise.reject(new y(t));
    }
    this._connectionStarted = !0;
  }
  send(e) {
    return this._connectionState !== "Connected" ? Promise.reject(new Error("Cannot send data if the connection is not in the 'Connected' State.")) : (this._sendQueue || (this._sendQueue = new j(this.transport)), this._sendQueue.send(e));
  }
  async stop(e) {
    if (this._connectionState === "Disconnected")
      return this._logger.log(r.Debug, `Call to HttpConnection.stop(${e}) ignored because the connection is already in the disconnected state.`), Promise.resolve();
    if (this._connectionState === "Disconnecting")
      return this._logger.log(r.Debug, `Call to HttpConnection.stop(${e}) ignored because the connection is already in the disconnecting state.`), this._stopPromise;
    this._connectionState = "Disconnecting", this._stopPromise = new Promise((t) => {
      this._stopPromiseResolver = t;
    }), await this._stopInternal(e), await this._stopPromise;
  }
  async _stopInternal(e) {
    this._stopError = e;
    try {
      await this._startInternalPromise;
    } catch {
    }
    if (this.transport) {
      try {
        await this.transport.stop();
      } catch (t) {
        this._logger.log(r.Error, `HttpConnection.transport.stop() threw error '${t}'.`), this._stopConnection();
      }
      this.transport = void 0;
    } else
      this._logger.log(r.Debug, "HttpConnection.transport is undefined in HttpConnection.stop() because start() failed.");
  }
  async _startInternal(e) {
    let t = this.baseUrl;
    this._accessTokenFactory = this._options.accessTokenFactory, this._httpClient._accessTokenFactory = this._accessTokenFactory;
    try {
      if (this._options.skipNegotiation)
        if (this._options.transport === m.WebSockets)
          this.transport = this._constructTransport(m.WebSockets), await this._startTransport(t, e);
        else
          throw new Error("Negotiation can only be skipped when using the WebSocket transport directly.");
      else {
        let n = null, o = 0;
        do {
          if (n = await this._getNegotiationResponse(t), this._connectionState === "Disconnecting" || this._connectionState === "Disconnected")
            throw new y("The connection was stopped during negotiation.");
          if (n.error)
            throw new Error(n.error);
          if (n.ProtocolVersion)
            throw new Error("Detected a connection attempt to an ASP.NET SignalR Server. This client only supports connecting to an ASP.NET Core SignalR Server. See https://aka.ms/signalr-core-differences for details.");
          if (n.url && (t = n.url), n.accessToken) {
            const i = n.accessToken;
            this._accessTokenFactory = () => i, this._httpClient._accessToken = i, this._httpClient._accessTokenFactory = void 0;
          }
          o++;
        } while (n.url && o < W);
        if (o === W && n.url)
          throw new Error("Negotiate redirection limit exceeded.");
        await this._createTransport(t, this._options.transport, n, e);
      }
      this.transport instanceof O && (this.features.inherentKeepAlive = !0), this._connectionState === "Connecting" && (this._logger.log(r.Debug, "The HttpConnection connected successfully."), this._connectionState = "Connected");
    } catch (n) {
      return this._logger.log(r.Error, "Failed to start the connection: " + n), this._connectionState = "Disconnected", this.transport = void 0, this._stopPromiseResolver(), Promise.reject(n);
    }
  }
  async _getNegotiationResponse(e) {
    const t = {}, [n, o] = T();
    t[n] = o;
    const i = this._resolveNegotiateUrl(e);
    this._logger.log(r.Debug, `Sending negotiation request: ${i}.`);
    try {
      const a = await this._httpClient.post(i, {
        content: "",
        headers: { ...t, ...this._options.headers },
        timeout: this._options.timeout,
        withCredentials: this._options.withCredentials
      });
      if (a.statusCode !== 200)
        return Promise.reject(new Error(`Unexpected status code returned from negotiate '${a.statusCode}'`));
      const c = JSON.parse(a.content);
      return (!c.negotiateVersion || c.negotiateVersion < 1) && (c.connectionToken = c.connectionId), c.useStatefulReconnect && this._options._useStatefulReconnect !== !0 ? Promise.reject(new H("Client didn't negotiate Stateful Reconnect but the server did.")) : c;
    } catch (a) {
      let c = "Failed to complete negotiation with the server: " + a;
      return a instanceof v && a.statusCode === 404 && (c = c + " Either this is not a SignalR endpoint or there is a proxy blocking the connection."), this._logger.log(r.Error, c), Promise.reject(new H(c));
    }
  }
  _createConnectUrl(e, t) {
    return t ? e + (e.indexOf("?") === -1 ? "?" : "&") + `id=${t}` : e;
  }
  async _createTransport(e, t, n, o) {
    let i = this._createConnectUrl(e, n.connectionToken);
    if (this._isITransport(t)) {
      this._logger.log(r.Debug, "Connection was provided an instance of ITransport, using that directly."), this.transport = t, await this._startTransport(i, o), this.connectionId = n.connectionId;
      return;
    }
    const a = [], c = n.availableTransports || [];
    let l = n;
    for (const h of c) {
      const d = this._resolveTransportOrError(h, t, o, (l == null ? void 0 : l.useStatefulReconnect) === !0);
      if (d instanceof Error)
        a.push(`${h.transport} failed:`), a.push(d);
      else if (this._isITransport(d)) {
        if (this.transport = d, !l) {
          try {
            l = await this._getNegotiationResponse(e);
          } catch (S) {
            return Promise.reject(S);
          }
          i = this._createConnectUrl(e, l.connectionToken);
        }
        try {
          await this._startTransport(i, o), this.connectionId = l.connectionId;
          return;
        } catch (S) {
          if (this._logger.log(r.Error, `Failed to start the transport '${h.transport}': ${S}`), l = void 0, a.push(new vt(`${h.transport} failed: ${S}`, m[h.transport])), this._connectionState !== "Connecting") {
            const L = "Failed to select transport before stop() was called.";
            return this._logger.log(r.Debug, L), Promise.reject(new y(L));
          }
        }
      }
    }
    return a.length > 0 ? Promise.reject(new Ct(`Unable to connect to the server with any of the available transports. ${a.join(" ")}`, a)) : Promise.reject(new Error("None of the transports supported by the client are supported by the server."));
  }
  _constructTransport(e) {
    switch (e) {
      case m.WebSockets:
        if (!this._options.WebSocket)
          throw new Error("'WebSocket' is not supported in your environment.");
        return new Zt(this._httpClient, this._accessTokenFactory, this._logger, this._options.logMessageContent, this._options.WebSocket, this._options.headers || {});
      case m.ServerSentEvents:
        if (!this._options.EventSource)
          throw new Error("'EventSource' is not supported in your environment.");
        return new Jt(this._httpClient, this._httpClient._accessToken, this._logger, this._options);
      case m.LongPolling:
        return new O(this._httpClient, this._logger, this._options);
      default:
        throw new Error(`Unknown transport: ${e}.`);
    }
  }
  _startTransport(e, t) {
    return this.transport.onreceive = this.onreceive, this.features.reconnect ? this.transport.onclose = async (n) => {
      let o = !1;
      if (this.features.reconnect)
        try {
          this.features.disconnected(), await this.transport.connect(e, t), await this.features.resend();
        } catch {
          o = !0;
        }
      else {
        this._stopConnection(n);
        return;
      }
      o && this._stopConnection(n);
    } : this.transport.onclose = (n) => this._stopConnection(n), this.transport.connect(e, t);
  }
  _resolveTransportOrError(e, t, n, o) {
    const i = m[e.transport];
    if (i == null)
      return this._logger.log(r.Debug, `Skipping transport '${e.transport}' because it is not supported by this client.`), new Error(`Skipping transport '${e.transport}' because it is not supported by this client.`);
    if (Xt(t, i))
      if (e.transferFormats.map((c) => b[c]).indexOf(n) >= 0) {
        if (i === m.WebSockets && !this._options.WebSocket || i === m.ServerSentEvents && !this._options.EventSource)
          return this._logger.log(r.Debug, `Skipping transport '${m[i]}' because it is not supported in your environment.'`), new yt(`'${m[i]}' is not supported in your environment.`, i);
        this._logger.log(r.Debug, `Selecting transport '${m[i]}'.`);
        try {
          return this.features.reconnect = i === m.WebSockets ? o : void 0, this._constructTransport(i);
        } catch (c) {
          return c;
        }
      } else
        return this._logger.log(r.Debug, `Skipping transport '${m[i]}' because it does not support the requested transfer format '${b[n]}'.`), new Error(`'${m[i]}' does not support ${b[n]}.`);
    else
      return this._logger.log(r.Debug, `Skipping transport '${m[i]}' because it was disabled by the client.`), new St(`'${m[i]}' is disabled by the client.`, i);
  }
  _isITransport(e) {
    return e && typeof e == "object" && "connect" in e;
  }
  _stopConnection(e) {
    if (this._logger.log(r.Debug, `HttpConnection.stopConnection(${e}) called while in state ${this._connectionState}.`), this.transport = void 0, e = this._stopError || e, this._stopError = void 0, this._connectionState === "Disconnected") {
      this._logger.log(r.Debug, `Call to HttpConnection.stopConnection(${e}) was ignored because the connection is already in the disconnected state.`);
      return;
    }
    if (this._connectionState === "Connecting")
      throw this._logger.log(r.Warning, `Call to HttpConnection.stopConnection(${e}) was ignored because the connection is still in the connecting state.`), new Error(`HttpConnection.stopConnection(${e}) was called while the connection is still in the connecting state.`);
    if (this._connectionState === "Disconnecting" && this._stopPromiseResolver(), e ? this._logger.log(r.Error, `Connection disconnected with error '${e}'.`) : this._logger.log(r.Information, "Connection disconnected."), this._sendQueue && (this._sendQueue.stop().catch((t) => {
      this._logger.log(r.Error, `TransportSendQueue.stop() threw error '${t}'.`);
    }), this._sendQueue = void 0), this.connectionId = void 0, this._connectionState = "Disconnected", this._connectionStarted) {
      this._connectionStarted = !1;
      try {
        this.onclose && this.onclose(e);
      } catch (t) {
        this._logger.log(r.Error, `HttpConnection.onclose(${e}) threw error '${t}'.`);
      }
    }
  }
  _resolveUrl(e) {
    if (e.lastIndexOf("https://", 0) === 0 || e.lastIndexOf("http://", 0) === 0)
      return e;
    if (!p.isBrowser)
      throw new Error(`Cannot resolve '${e}'.`);
    const t = window.document.createElement("a");
    return t.href = e, this._logger.log(r.Information, `Normalizing '${e}' to '${t.href}'.`), t.href;
  }
  _resolveNegotiateUrl(e) {
    const t = new URL(e);
    t.pathname.endsWith("/") ? t.pathname += "negotiate" : t.pathname += "/negotiate";
    const n = new URLSearchParams(t.searchParams);
    return n.has("negotiateVersion") || n.append("negotiateVersion", this._negotiateVersion.toString()), n.has("useStatefulReconnect") ? n.get("useStatefulReconnect") === "true" && (this._options._useStatefulReconnect = !0) : this._options._useStatefulReconnect === !0 && n.append("useStatefulReconnect", "true"), t.search = n.toString(), t.toString();
  }
}
function Xt(s, e) {
  return !s || (e & s) !== 0;
}
class j {
  constructor(e) {
    this._transport = e, this._buffer = [], this._executing = !0, this._sendBufferedData = new A(), this._transportResult = new A(), this._sendLoopPromise = this._sendLoop();
  }
  send(e) {
    return this._bufferData(e), this._transportResult || (this._transportResult = new A()), this._transportResult.promise;
  }
  stop() {
    return this._executing = !1, this._sendBufferedData.resolve(), this._sendLoopPromise;
  }
  _bufferData(e) {
    if (this._buffer.length && typeof this._buffer[0] != typeof e)
      throw new Error(`Expected data to be of type ${typeof this._buffer} but was of type ${typeof e}`);
    this._buffer.push(e), this._sendBufferedData.resolve();
  }
  async _sendLoop() {
    for (; ; ) {
      if (await this._sendBufferedData.promise, !this._executing) {
        this._transportResult && this._transportResult.reject("Connection stopped.");
        break;
      }
      this._sendBufferedData = new A();
      const e = this._transportResult;
      this._transportResult = void 0;
      const t = typeof this._buffer[0] == "string" ? this._buffer.join("") : j._concatBuffers(this._buffer);
      this._buffer.length = 0;
      try {
        await this._transport.send(t), e.resolve();
      } catch (n) {
        e.reject(n);
      }
    }
  }
  static _concatBuffers(e) {
    const t = e.map((i) => i.byteLength).reduce((i, a) => i + a), n = new Uint8Array(t);
    let o = 0;
    for (const i of e)
      n.set(new Uint8Array(i), o), o += i.byteLength;
    return n.buffer;
  }
}
class A {
  constructor() {
    this.promise = new Promise((e, t) => [this._resolver, this._rejecter] = [e, t]);
  }
  resolve() {
    this._resolver();
  }
  reject(e) {
    this._rejecter(e);
  }
}
const Kt = "json";
class Gt {
  constructor() {
    this.name = Kt, this.version = 2, this.transferFormat = b.Text;
  }
  /** Creates an array of {@link @microsoft/signalr.HubMessage} objects from the specified serialized representation.
   *
   * @param {string} input A string containing the serialized representation.
   * @param {ILogger} logger A logger that will be used to log messages that occur during parsing.
   */
  parseMessages(e, t) {
    if (typeof e != "string")
      throw new Error("Invalid input for JSON hub protocol. Expected a string.");
    if (!e)
      return [];
    t === null && (t = E.instance);
    const n = w.parse(e), o = [];
    for (const i of n) {
      const a = JSON.parse(i);
      if (typeof a.type != "number")
        throw new Error("Invalid payload.");
      switch (a.type) {
        case u.Invocation:
          this._isInvocationMessage(a);
          break;
        case u.StreamItem:
          this._isStreamItemMessage(a);
          break;
        case u.Completion:
          this._isCompletionMessage(a);
          break;
        case u.Ping:
          break;
        case u.Close:
          break;
        case u.Ack:
          this._isAckMessage(a);
          break;
        case u.Sequence:
          this._isSequenceMessage(a);
          break;
        default:
          t.log(r.Information, "Unknown message type '" + a.type + "' ignored.");
          continue;
      }
      o.push(a);
    }
    return o;
  }
  /** Writes the specified {@link @microsoft/signalr.HubMessage} to a string and returns it.
   *
   * @param {HubMessage} message The message to write.
   * @returns {string} A string containing the serialized representation of the message.
   */
  writeMessage(e) {
    return w.write(JSON.stringify(e));
  }
  _isInvocationMessage(e) {
    this._assertNotEmptyString(e.target, "Invalid payload for Invocation message."), e.invocationId !== void 0 && this._assertNotEmptyString(e.invocationId, "Invalid payload for Invocation message.");
  }
  _isStreamItemMessage(e) {
    if (this._assertNotEmptyString(e.invocationId, "Invalid payload for StreamItem message."), e.item === void 0)
      throw new Error("Invalid payload for StreamItem message.");
  }
  _isCompletionMessage(e) {
    if (e.result && e.error)
      throw new Error("Invalid payload for Completion message.");
    !e.result && e.error && this._assertNotEmptyString(e.error, "Invalid payload for Completion message."), this._assertNotEmptyString(e.invocationId, "Invalid payload for Completion message.");
  }
  _isAckMessage(e) {
    if (typeof e.sequenceId != "number")
      throw new Error("Invalid SequenceId for Ack message.");
  }
  _isSequenceMessage(e) {
    if (typeof e.sequenceId != "number")
      throw new Error("Invalid SequenceId for Sequence message.");
  }
  _assertNotEmptyString(e, t) {
    if (typeof e != "string" || e === "")
      throw new Error(t);
  }
}
const Yt = {
  trace: r.Trace,
  debug: r.Debug,
  info: r.Information,
  information: r.Information,
  warn: r.Warning,
  warning: r.Warning,
  error: r.Error,
  critical: r.Critical,
  none: r.None
};
function Qt(s) {
  const e = Yt[s.toLowerCase()];
  if (typeof e < "u")
    return e;
  throw new Error(`Unknown log level: ${s}`);
}
class en {
  configureLogging(e) {
    if (_.isRequired(e, "logging"), tn(e))
      this.logger = e;
    else if (typeof e == "string") {
      const t = Qt(e);
      this.logger = new P(t);
    } else
      this.logger = new P(e);
    return this;
  }
  withUrl(e, t) {
    return _.isRequired(e, "url"), _.isNotEmpty(e, "url"), this.url = e, typeof t == "object" ? this.httpConnectionOptions = { ...this.httpConnectionOptions, ...t } : this.httpConnectionOptions = {
      ...this.httpConnectionOptions,
      transport: t
    }, this;
  }
  /** Configures the {@link @microsoft/signalr.HubConnection} to use the specified Hub Protocol.
   *
   * @param {IHubProtocol} protocol The {@link @microsoft/signalr.IHubProtocol} implementation to use.
   */
  withHubProtocol(e) {
    return _.isRequired(e, "protocol"), this.protocol = e, this;
  }
  withAutomaticReconnect(e) {
    if (this.reconnectPolicy)
      throw new Error("A reconnectPolicy has already been set.");
    return e ? Array.isArray(e) ? this.reconnectPolicy = new B(e) : this.reconnectPolicy = e : this.reconnectPolicy = new B(), this;
  }
  /** Configures {@link @microsoft/signalr.HubConnection.serverTimeoutInMilliseconds} for the {@link @microsoft/signalr.HubConnection}.
   *
   * @returns The {@link @microsoft/signalr.HubConnectionBuilder} instance, for chaining.
   */
  withServerTimeout(e) {
    return _.isRequired(e, "milliseconds"), this._serverTimeoutInMilliseconds = e, this;
  }
  /** Configures {@link @microsoft/signalr.HubConnection.keepAliveIntervalInMilliseconds} for the {@link @microsoft/signalr.HubConnection}.
   *
   * @returns The {@link @microsoft/signalr.HubConnectionBuilder} instance, for chaining.
   */
  withKeepAliveInterval(e) {
    return _.isRequired(e, "milliseconds"), this._keepAliveIntervalInMilliseconds = e, this;
  }
  /** Enables and configures options for the Stateful Reconnect feature.
   *
   * @returns The {@link @microsoft/signalr.HubConnectionBuilder} instance, for chaining.
   */
  withStatefulReconnect(e) {
    return this.httpConnectionOptions === void 0 && (this.httpConnectionOptions = {}), this.httpConnectionOptions._useStatefulReconnect = !0, this._statefulReconnectBufferSize = e == null ? void 0 : e.bufferSize, this;
  }
  /** Creates a {@link @microsoft/signalr.HubConnection} from the configuration options specified in this builder.
   *
   * @returns {HubConnection} The configured {@link @microsoft/signalr.HubConnection}.
   */
  build() {
    const e = this.httpConnectionOptions || {};
    if (e.logger === void 0 && (e.logger = this.logger), !this.url)
      throw new Error("The 'HubConnectionBuilder.withUrl' method must be called before building the connection.");
    const t = new Vt(this.url, e);
    return x.create(t, this.logger || E.instance, this.protocol || new Gt(), this.reconnectPolicy, this._serverTimeoutInMilliseconds, this._keepAliveIntervalInMilliseconds, this._statefulReconnectBufferSize);
  }
}
function tn(s) {
  return s.log !== void 0;
}
const J = "Benachrichtigungen", Z = "Alle anzeigen", V = "Alle löschen", X = "Keine Benachrichtigungen", K = "Ihre neuen Benachrichtigungen werden hier erscheinen.", G = "Zu meinen Nachrichten", Y = [
  "vor 1 Stunde",
  "vor 2 Stunden",
  "vor 1 Tag",
  "vor 2 Tagen",
  "vor 1 Woche",
  "vor 2 Wochen",
  "vor 1 Jahr",
  "vor 2 Jahren"
], nn = {
  label: J,
  viewAll: Z,
  clearAll: V,
  noNotifications: X,
  emptyStateDescription: K,
  goToMyMessages: G,
  timeFrame: Y
}, on = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  label: J,
  viewAll: Z,
  clearAll: V,
  noNotifications: X,
  emptyStateDescription: K,
  goToMyMessages: G,
  timeFrame: Y,
  default: nn
}), Q = "Notifications", ee = "View all", te = "Clear all", ne = "No notifications", oe = "Your new notifications will appear here.", se = "Go to my messages", ie = [
  "1 day ago",
  "2 days ago",
  "1 week ago",
  "2 weeks ago",
  "1 year ago",
  "2 years ago"
], sn = {
  label: Q,
  viewAll: ee,
  clearAll: te,
  noNotifications: ne,
  emptyStateDescription: oe,
  goToMyMessages: se,
  timeFrame: ie
}, rn = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  label: Q,
  viewAll: ee,
  clearAll: te,
  noNotifications: ne,
  emptyStateDescription: oe,
  goToMyMessages: se,
  timeFrame: ie,
  default: sn
}), re = "Notificaciones", ae = "Ver todo", ce = "Borrar todo", le = "Sin notificaciones", he = "Tus nuevas notificaciones aparecerán aquí.", ue = "Ir a Mis Mensajes", an = {
  label: re,
  viewAll: ae,
  clearAll: ce,
  noNotifications: le,
  emptyStateDescription: he,
  goToMyMessages: ue
}, cn = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  label: re,
  viewAll: ae,
  clearAll: ce,
  noNotifications: le,
  emptyStateDescription: he,
  goToMyMessages: ue,
  default: an
}), de = "Notifications", ge = "Tout voir", fe = "Tout effacer", pe = "Aucune notification", _e = "Vos nouvelles notifications apparaîtront ici.", me = "Aller à Mes Messages", ln = {
  label: de,
  viewAll: ge,
  clearAll: fe,
  noNotifications: pe,
  emptyStateDescription: _e,
  goToMyMessages: me
}, hn = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  label: de,
  viewAll: ge,
  clearAll: fe,
  noNotifications: pe,
  emptyStateDescription: _e,
  goToMyMessages: me,
  default: ln
}), be = "Notifiche", we = "Visualizza tutto", ye = "Cancella tutto", Se = "Nessuna notifica", ve = "Le tue nuove notifiche appariranno qui.", Ce = "Vai ai miei messaggi", un = {
  label: be,
  viewAll: we,
  clearAll: ye,
  noNotifications: Se,
  emptyStateDescription: ve,
  goToMyMessages: Ce
}, dn = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  label: be,
  viewAll: we,
  clearAll: ye,
  noNotifications: Se,
  emptyStateDescription: ve,
  goToMyMessages: Ce,
  default: un
}), ke = "通知", Te = "すべて表示", Ie = "すべてクリア", Ee = "通知はありません", $e = "新しい通知がここに表示されます。", Ae = "私のメッセージに移動", Pe = [
  "1日前",
  "2日前",
  "1週間前",
  "2週間前",
  "1年前",
  "2年前"
], gn = {
  label: ke,
  viewAll: Te,
  clearAll: Ie,
  noNotifications: Ee,
  emptyStateDescription: $e,
  goToMyMessages: Ae,
  timeFrame: Pe
}, fn = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  label: ke,
  viewAll: Te,
  clearAll: Ie,
  noNotifications: Ee,
  emptyStateDescription: $e,
  goToMyMessages: Ae,
  timeFrame: Pe,
  default: gn
}), Re = "Korean", Ne = "알림", Me = "모두 보기", De = "모두 지우기", xe = [
  "1일 전",
  "2일 전",
  "1주일 전",
  "2주 전",
  "1년 전",
  "2년 전"
], pn = {
  language: Re,
  label: Ne,
  viewAll: Me,
  clearAll: De,
  timeFrame: xe
}, _n = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  language: Re,
  label: Ne,
  viewAll: Me,
  clearAll: De,
  timeFrame: xe,
  default: pn
}), je = "Dutch", Le = "Meldingen", He = "Alles weergeven", Ue = "Alles verwijderen", Be = [
  "1 uur geleden",
  "2 uur geleden",
  "1 dag geleden",
  "2 dagen geleden",
  "1 week geleden",
  "2 weken geleden",
  "1 jaar geleden",
  "2 jaar geleden"
], mn = {
  language: je,
  label: Le,
  viewAll: He,
  clearAll: Ue,
  timeFrame: Be
}, bn = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  language: je,
  label: Le,
  viewAll: He,
  clearAll: Ue,
  timeFrame: Be,
  default: mn
}), Oe = "Polish", We = "Powiadomienia", Fe = "Pokaż wszystkie", ze = "Usuń wszystkie", qe = [
  "1 dzień temu",
  "2 dni temu",
  "1 tydzień temu",
  "2 tygodnie temu",
  "1 rok temu",
  "2 lata temu"
], wn = {
  language: Oe,
  label: We,
  viewAll: Fe,
  clearAll: ze,
  timeFrame: qe
}, yn = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  language: Oe,
  label: We,
  viewAll: Fe,
  clearAll: ze,
  timeFrame: qe,
  default: wn
}), Je = "Notificações", Ze = "Ver tudo", Ve = "Limpar tudo", Xe = "Sem notificações", Ke = "Suas novas notificações aparecerão aqui.", Ge = "Ir para MyMessages", Sn = {
  label: Je,
  viewAll: Ze,
  clearAll: Ve,
  noNotifications: Xe,
  emptyStateDescription: Ke,
  goToMyMessages: Ge
}, vn = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  label: Je,
  viewAll: Ze,
  clearAll: Ve,
  noNotifications: Xe,
  emptyStateDescription: Ke,
  goToMyMessages: Ge,
  default: Sn
}), Ye = "Уведомления", Qe = "Посмотреть все", et = "Очистить все", tt = "Нет уведомлений", nt = "Ваши новые уведомления будут появляться здесь.", ot = "Перейти к Моим сообщениям", Cn = {
  label: Ye,
  viewAll: Qe,
  clearAll: et,
  noNotifications: tt,
  emptyStateDescription: nt,
  goToMyMessages: ot
}, kn = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  label: Ye,
  viewAll: Qe,
  clearAll: et,
  noNotifications: tt,
  emptyStateDescription: nt,
  goToMyMessages: ot,
  default: Cn
}), st = "Turkish", it = "Bildirimler", rt = "Tümünü görüntüle", at = "Tümünü temizle", ct = [
  "1 gün önce",
  "2 gün önce",
  "1 hafta önce",
  "2 hafta önce",
  "1 yıl önce",
  "2 yıl önce"
], Tn = {
  language: st,
  label: it,
  viewAll: rt,
  clearAll: at,
  timeFrame: ct
}, In = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  language: st,
  label: it,
  viewAll: rt,
  clearAll: at,
  timeFrame: ct,
  default: Tn
}), lt = "通知", ht = "查看全部", ut = "清除全部", dt = "没有通知", gt = "您的新通知将出现在这里。", ft = "转到我的消息", En = {
  label: lt,
  viewAll: ht,
  clearAll: ut,
  noNotifications: dt,
  emptyStateDescription: gt,
  goToMyMessages: ft
}, $n = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  label: lt,
  viewAll: ht,
  clearAll: ut,
  noNotifications: dt,
  emptyStateDescription: gt,
  goToMyMessages: ft,
  default: En
}), An = [
  {
    id: 1,
    myMessageId: "message1",
    genreName: "Licences and Services",
    iconName: "envelope",
    subject: "This is a mocked message",
    publishedAt: "2025-01-23T16:05:41Z",
    publishedSince: "2025-01-23T16:05:41Z",
    isRead: !1,
    isConfirmed: !0,
    isImportant: !0
  },
  {
    id: 2,
    myMessageId: "message2",
    genreName: "Liebherr Account",
    iconName: "modern-workplace-production",
    subject: "This is a mocked message",
    publishedAt: "2021-01-23T16:05:41Z",
    publishedSince: "2021-01-23T16:05:41Z",
    isRead: !0,
    isConfirmed: !1,
    isImportant: !1
  },
  {
    id: 3,
    myMessageId: "message3",
    genreName: "Licences and Services",
    iconName: "webshop",
    subject: "This is a mocked message",
    publishedAt: "2025-01-17T16:05:41Z",
    publishedSince: "2025-01-17T16:05:41Z",
    isRead: !1,
    isConfirmed: !0,
    isImportant: !1
  },
  {
    id: 4,
    myMessageId: "message4",
    genreName: "Licences and Services",
    iconName: "modern-workplace-production",
    subject: "This is a mocked message",
    publishedAt: void 0,
    publishedSince: void 0,
    isRead: !1,
    isConfirmed: !1,
    isImportant: !0
  },
  {
    id: 5,
    myMessageId: "message5",
    genreName: "Licences and Services",
    iconName: "webshop",
    subject: "This is a mocked message",
    publishedAt: null,
    publishedSince: null,
    isRead: !0,
    isConfirmed: !0,
    isImportant: !0
  },
  {
    id: 6,
    myMessageId: "message6",
    genreName: "Licences and Services",
    iconName: "envelope",
    subject: "This is a mocked message",
    publishedAt: "2025-01-23T16:05:41Z",
    publishedSince: "2025-01-23T16:05:41Z",
    isRead: !1,
    isConfirmed: !1,
    isImportant: !1
  },
  {
    id: 7,
    myMessageId: "message7",
    genreName: "Licences and Services",
    iconName: "envelope",
    subject: "This is a mocked message",
    publishedAt: "2025-01-23T16:05:41Z",
    publishedSince: "2025-01-23T16:05:41Z",
    isRead: !0,
    isConfirmed: !1,
    isImportant: !1
  },
  {
    id: 8,
    myMessageId: "message8",
    genreName: "Licences and Services",
    iconName: "modern-workplace-production",
    subject: "This is a mocked message",
    publishedAt: "2025-01-23T16:05:41Z",
    publishedSince: "2025-01-23T16:05:41Z",
    isRead: !1,
    isConfirmed: !0,
    isImportant: !1
  },
  {
    id: 9,
    myMessageId: "message9",
    genreName: "Licences and Services",
    iconName: "webshop",
    subject: "This is a mocked message",
    publishedAt: "2025-01-23T16:05:41Z",
    publishedSince: "2025-01-23T16:05:41Z",
    isRead: !1,
    isConfirmed: !1,
    isImportant: !0
  },
  {
    id: 10,
    myMessageId: "message10",
    genreName: "Licences and Services",
    iconName: "envelope",
    subject: "This is a mocked message",
    publishedAt: "2025-01-23T16:05:41Z",
    publishedSince: "2025-01-23T16:05:41Z",
    isRead: !0,
    isConfirmed: !0,
    isImportant: !0
  },
  {
    id: 11,
    myMessageId: "message11",
    genreName: "Licences and Services",
    iconName: "envelope",
    subject: "This is a mocked message",
    publishedAt: "2025-01-23T16:05:41Z",
    publishedSince: "2025-01-23T16:05:41Z",
    isRead: !0,
    isConfirmed: !0,
    isImportant: !0
  },
  {
    id: 12,
    myMessageId: "message12",
    genreName: "Licences and Services",
    iconName: "webshop",
    subject: "This is a mocked message",
    publishedAt: "2025-01-23T16:05:41Z",
    publishedSince: "2025-01-23T16:05:41Z",
    isRead: !0,
    isConfirmed: !0,
    isImportant: !0
  }
], Pn = "*,:after,:before{border-color:var(--color-neutral-steel-200);border-style:solid;border-width:0;box-sizing:border-box}a{color:inherit;text-decoration:inherit}audio,canvas,embed,iframe,img,object,svg,video{display:block;vertical-align:middle}button,input,optgroup,select,textarea{font-feature-settings:inherit;color:inherit;font-family:inherit;font-size:100%;font-variation-settings:inherit;font-weight:inherit;letter-spacing:inherit;line-height:inherit;margin:0;padding:0}blockquote,dd,dl,fieldset,figure,h1,h2,h3,h4,h5,h6,hr,p,pre{margin:0}fieldset,legend{padding:0}.static{position:static}.mb-3{margin-bottom:var(--spacing-3)}.flex{display:flex}.h-\\[445px\\]{height:445px}.cursor-pointer{cursor:pointer}.items-center{align-items:center}.justify-center{justify-content:center}.text-gray-800{color:var(--color-neutral-steel-800)}.filter{filter:var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow)}", Rn = Pn, F = {
  de: on,
  en: rn,
  es: cn,
  fr: hn,
  it: dn,
  ja: fn,
  pt: vn,
  ru: kn,
  zh: $n,
  ko: _n,
  nl: bn,
  pl: yn,
  tr: In
}, M = An, Nn = class {
  constructor(s) {
    pt(this, s), this.unseenNotificationCountChange = _t(this, "lhUnseenNotificationCountChange", 7), this.API_BASE_URLS = {
      "local-dev": "https://localhost:5005/",
      test: "https://apigwtst.liebherr.com/comhub/",
      prod: "https://apigw.liebherr.com/comhub/"
    }, this.HUB_BASE_URLS = {
      "local-dev": "https://localhost:5011/",
      test: "https://apigwtst.liebherr.com/comhub/",
      prod: "https://apigw.liebherr.com/comhub/"
    }, this.MY_MESSAGES_URLS = {
      "local-dev": "https://localhost:5001/messages/",
      test: "https://logintst.liebherr.com/profile/messages/",
      prod: "https://login.liebherr.com/profile/messages/"
    }, this.languageChangeListener = async (e) => {
      this.languageCode = e, this.i18n = I.resolveJsonBasedOnLanguage(e, F), await this.loadNotifications();
    }, this.lazyLoadOnScrollEnd = async (e) => {
      const { scrollHeight: t, scrollTop: n, clientHeight: o } = e.detail.target, i = Math.abs(t - o - n) < this.height, a = this.notifications.length === this.totalNotificationCount;
      i && !this.isLoading && !a && await this.loadNotifications();
    }, this.resetUnseenNotificationCounter = async () => {
      var e;
      if (this.unseenNotificationCount > 0)
        try {
          const t = `${(e = this.baseUrl) !== null && e !== void 0 ? e : this.API_BASE_URLS[this.environment]}api/users/me/resetnotificationcounter`, n = await fetch(t, {
            method: "GET",
            headers: this.setHeaders()
          });
          if (!n.ok)
            throw new Error(n.statusText);
          this.unseenNotificationCount = 0;
        } catch (t) {
          console.error(t);
        } finally {
          this.isLoading = !1;
        }
    }, this.clearAllNotifications = async () => {
      var e;
      try {
        const t = `${(e = this.baseUrl) !== null && e !== void 0 ? e : this.API_BASE_URLS[this.environment]}api/users/me/notifications/clear`, n = await fetch(t, {
          method: "GET",
          headers: this.setHeaders()
        });
        if (!n.ok)
          throw new Error(n.statusText);
        this.notifications = [], this.totalNotificationCount = 0;
      } catch (t) {
        console.error(t);
      }
    }, this.clearNotificationById = (e) => async (t) => {
      var n;
      t.stopPropagation(), t.preventDefault();
      try {
        const o = `${(n = this.baseUrl) !== null && n !== void 0 ? n : this.API_BASE_URLS[this.environment]}api/users/me/notifications/${e}/clear`, i = await fetch(o, {
          method: "GET",
          headers: this.setHeaders()
        });
        if (!i.ok)
          throw new Error(i.statusText);
        this.notifications = this.notifications.filter((a) => a.id !== e), this.totalNotificationCount--;
      } catch (o) {
        console.error(o);
      }
    }, this.navigateToMyMessageById = (e) => () => {
      if (e !== null) {
        const t = `${this.MY_MESSAGES_URLS[this.environment]}${e}`;
        window.location.href = t;
      }
    }, this.navigateToMyMessage = async () => {
      window.location.href = this.MY_MESSAGES_URLS[this.environment];
    }, this.width = 700, this.height = 600, this.mockedData = !1, this.headerFirstRow = !1, this.isOpen = !1, this.notifications = [], this.totalNotificationCount = 0, this.unseenNotificationCount = 0, this.i18n = void 0, this.languageCode = void 0, this.accessToken = null, this.baseUrl = null, this.environment = "prod", this.isLoading = !1, this.httpErrorCode = null;
  }
  /**
   * Observe the unseenNotificationCount property and emit an event if it changes.
   */
  watchUnseenNotificationCountHandler(s, e) {
    s !== e && this.unseenNotificationCountChange.emit(s);
  }
  disconnectedCallback() {
    I.getInstance().off("onLanguageChange", this.languageChangeListener);
  }
  async componentWillLoad() {
    this.languageCode = await I.getCurrentLanguage();
    const s = I.getInstance();
    this.i18n = I.resolveJsonBasedOnLanguage(this.languageCode, F), s.on("onLanguageChange", this.languageChangeListener), this.loadNotifications(), this.initWebSocket();
  }
  async loadNotifications() {
    var s;
    if (!this.isLoading) {
      if (this.mockedData) {
        this.unseenNotificationCount = M.filter((e) => !e.isRead).length, this.totalNotificationCount = M.length, this.notifications.push(...M.map((e) => Object.assign(Object.assign({}, e), { publishedSince: this.convertToTimeSinceString(e.publishedAt) })));
        return;
      }
      try {
        this.isLoading = !0;
        const e = 15, t = this.notifications.length, n = `${(s = this.baseUrl) !== null && s !== void 0 ? s : this.API_BASE_URLS[this.environment]}api/users/me/notifications?skip=${t}&limit=${e}`, o = await fetch(n, {
          method: "GET",
          headers: this.setHeaders()
        });
        if (!o.ok)
          throw this.httpErrorCode = o.status, new Error(o.statusText);
        const i = await o.json();
        this.notifications.push(...i.notifications.map((a) => Object.assign(Object.assign({}, a), { publishedSince: this.convertToTimeSinceString(a.publishedAt) }))), this.unseenNotificationCount = i.unseenNotificationCount, this.totalNotificationCount = i.totalNotificationCount;
      } catch (e) {
        console.error(e), this.httpErrorCode === null && (this.httpErrorCode = 400);
      } finally {
        this.isLoading = !1;
      }
    }
  }
  convertToTimeSinceString(s) {
    if (!s)
      return "";
    const e = wt.fromISO(s, { zone: "UTC" }).toJSDate(), n = (/* @__PURE__ */ new Date()).getTime() - e.getTime(), o = Math.floor(n / 1e3), i = Math.floor(o / 60), a = Math.floor(i / 60), c = Math.floor(a / 24), l = Math.floor(c / 7), h = Math.floor(c / 30), d = Math.floor(c / 365);
    return d > 0 ? d + (d === 1 ? " year" : " years") + " ago" : h > 0 ? h + (h === 1 ? " month" : " months") + " ago" : l > 0 ? l + (l === 1 ? " week" : " weeks") + " ago" : c > 0 ? c + (c === 1 ? " day" : " days") + " ago" : a > 0 ? a + (a === 1 ? " hour" : " hours") + " ago" : i > 0 ? i + (i === 1 ? " minute" : " minutes") + " ago" : o + (o === 1 ? " second" : " seconds") + " ago";
  }
  async initWebSocket() {
    var s;
    const e = new en().withUrl(`${(s = this.baseUrl) !== null && s !== void 0 ? s : this.HUB_BASE_URLS[this.environment]}hub/notifications`, this.accessToken !== null ? { accessTokenFactory: () => this.accessToken } : { headers: { "X-CSRF": "1" } }).withAutomaticReconnect().build();
    e.serverTimeoutInMilliseconds = 6e4, e.on("notificationReceived", (t) => {
      this.unseenNotificationCount++, this.totalNotificationCount++, this.notifications = [
        Object.assign(Object.assign({}, t), { publishedSince: this.convertToTimeSinceString(t.publishedAt) }),
        ...this.notifications
      ];
    });
    try {
      await e.start();
    } catch (t) {
      console.error(t);
    }
  }
  setHeaders() {
    const s = {
      "Content-Type": "application/json",
      "Accept-Language": this.languageCode
    };
    return this.baseUrl === null || this.baseUrl === void 0 ? Object.assign(Object.assign({}, s), { Authorization: `Bearer ${this.accessToken}` }) : Object.assign(Object.assign({}, s), { "X-CSRF": "1" });
  }
  render() {
    return g(mt, { key: "f2c2ed6bb8a25c07dcb0301b7be4bf81c6fb3d91" }, g("patternlib-panel-flyout", { key: "0907f0bd36408c5cb1a2c6135ca4b31dbadc313f", width: this.width, height: this.height, headerFirstRow: this.headerFirstRow, onLhScroll: this.lazyLoadOnScrollEnd }, g("patternlib-navigation-icon-item", { key: "a0915932e3b26e67812354ba67c05b956fe8da07", slot: "element-icon", iconName: "my-notifier", badge: this.unseenNotificationCount < 100 ? this.unseenNotificationCount.toString() : "99+", onClick: this.resetUnseenNotificationCounter }), g("div", { key: "8f0f100a7acdcee3dc2676d2c76106ae78c25081", slot: "flyout-headline" }, this.i18n.label, " ", this.totalNotificationCount > 0 ? "(" + this.totalNotificationCount + ")" : ""), this.totalNotificationCount > 0 && g("div", { key: "1186599ff148ba03a4ba9d007a74c1914f9fe809", slot: "flyout-action-right" }, g("patternlib-link", { key: "fb3b3f00493e3b638abd05c7dd7abbf9280c29d4", type: "prominent", label: this.i18n.viewAll, variant: "context", onClick: this.navigateToMyMessage })), g("div", { key: "77c008d18bce0fb494b55ed95148b45e0caf8cfc", slot: "flyout-items" }, this.renderNotificationItems(), !this.isLoading && this.notifications.length === 0 && this.httpErrorCode === null ? this.renderEmptyState() : null, this.isLoading ? g("div", { class: "flex justify-center items-center h-[445px]" }, g("patternlib-spinner", { spin: !0 })) : null, !this.isLoading && this.httpErrorCode !== null ? g("patternlib-http-error-frame", { "status-code": this.httpErrorCode }) : null), g("div", { key: "0b64fb2f9d19eac65ad63a73470e4387849412fe", slot: "flyout-action-left" }, this.totalNotificationCount > 0 && g("div", { key: "bf3a6d6ab0f7b60dc432339f21649a684655c0db", slot: "flyout-action-left" }, g("patternlib-link", { key: "242611fa0f2fce858e1b04f2fb3291d96a21c05b", type: "prominent", label: this.i18n.clearAll, variant: "action", icon: "x", onClick: this.clearAllNotifications })))));
  }
  renderNotificationItems() {
    return this.notifications.map((s) => {
      var e;
      const t = {
        "cursor-pointer": s.myMessageId !== null
      };
      return g("patternlib-notification-item", { key: s.id, class: t, isImportant: s.isImportant, viewed: s.isRead, onClick: this.navigateToMyMessageById(s.myMessageId) }, g("div", { slot: "icon-start" }, g("patternlib-message-type-item", { type: "icon", iconName: (e = s.iconName) !== null && e !== void 0 ? e : "envelope" })), g("div", { slot: "headline" }, s.subject), g("div", { slot: "info" }, s.publishedSince ? s.publishedSince + " • " : "", s.genreName), g("div", { slot: "icon-end" }, g("patternlib-icon-button", { onClick: this.clearNotificationById(s.id) }, g("patternlib-icon", { "icon-name": "x", size: "24px" }))));
    });
  }
  renderEmptyState() {
    return g("div", { class: "flex justify-center" }, g("patternlib-empty-state", { size: "small", class: "mb-3", headline: this.i18n.noNotifications }, g("patternlib-empty-state-visual", { slot: "visual", size: "big", iconName: "my-notifier" }), g("p", { slot: "description", class: "mb-3 text-gray-800" }, this.i18n.emptyStateDescription), g("patternlib-button", { label: this.i18n.goToMyMessages, "icon-position": "right", onClick: this.navigateToMyMessage }, g("patternlib-icon", { slot: "icon", iconName: "font-arrow", size: "24px" }))));
  }
  get element() {
    return bt(this);
  }
  static get watchers() {
    return {
      unseenNotificationCount: ["watchUnseenNotificationCountHandler"]
    };
  }
};
Nn.style = Rn;
export {
  Nn as patternlib_notification_flyout_service
};
